import React, { useState, useRef, useEffect, useCallback } from "react";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://192.168.1.31:5000";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://interpreterflask.iugroup.com";
// 172.18.38.84
const API_BASE_URL1 = "https://erp.iugroup.com";

const STORAGE_KEYS = {
  VIEW: "chatAppView",
  SESSION: "chatAppSession",
  HELP_DESK: "chatAppHelpDeskState",
  TOKEN: "chatAppToken",
  EMAIL: "chatAppEmail",
  MODE: "chatAppMode",
};

const HELP_DESK_SUGGESTIONS = [
  "How to contact customer service?",
  "How to become Interpreter?",
  "What is the cancellation policy?",
"How to create an account?",
  { type: "ticket", label: "Register Support Ticket" },
];

const USER_TYPE_SUGGESTIONS = {
  contact: [
    "Today's Events",
    "Past Events",
    "Future Events",
    { type: "ticket", label: "Register Support Ticket" },
  ],
  vendor: [
    "Job Offered Events",
    "Today's Events",
    "Past Events",
    "Future Events",
    "Pending Timesheet Events",
    { type: "ticket", label: "Register Support Ticket" },
  ],
};

const CUSTOM_QUERY_EXAMPLES_APPOINTMENT_INTERPRETER = [
  "Show upcoming events?",
  "What events have I interpreted in the past?",
  "What are the details of my event at 'Miami City Hall'?",
  "Show me today's events",
  "Display my future events",
  "What is my next appointment?",
  "Show events for this week",
  "List all my scheduled events",
  "What events do I have tomorrow?",
  "Show my past interpreted events",
  "Display event details by event ID",
];

const CUSTOM_QUERY_EXAMPLES_HELP_INTERPRETER = [
  "How to reset my password?",
  "How to see the events details?",
  "How to see the timesheet details?",
  "How do I submit a timesheet?",
  "How to accept a job offer?",
  "How to reject a job?",
  "How to update my profile?",
  "How to change my password?",
  "What is the timesheet submission process?",
  "How to view my earnings?",
  "How to contact support?",
  "How to update my availability?",
];

const CUSTOM_QUERY_EXAMPLES_APPOINTMENT_CUSTOMER = [
  "Show my upcoming booked events?",
  "What events have I requested in the past?",
  "What are the details of my upcoming appointment?",
  "Show me today's appointments",
  "Display my future bookings",
  "What is my next appointment?",
  "Show appointments for this week",
  "List all my scheduled appointments",
  "What appointments do I have tomorrow?",
  "Show my past booked events",
  "Display appointment details",
];

const CUSTOM_QUERY_EXAMPLES_HELP_CUSTOMER = [
  "How can I see details of my booking?",
  "How do I update or cancel an appointment?",
  "How can I view my interpreter details?",
  "How to book a new appointment?",
  "How to reschedule an appointment?",
  "How to cancel my booking?",
  "How to contact my interpreter?",
  "How to update my profile?",
  "How to change my password?",
  "What services are available?",
  "How to contact support?",
  "How to view my booking history?",
];

const HELP_DESK_QUERY_SUGGESTIONS = [
  "How to contact customer service?",
  "How to become Interpreter?",
  "What is the cancellation policy?",
  "Which type of service is provided by IU Group?",
  "How to reset password?",
  "How to create an account?",
  "How to book an appointment?",
  "What are the service hours?",
  "How to cancel a booking?",
  "How to update profile information?",
  "What languages are supported?",
  "How to contact support?",
  "How to register as an interpreter?",
  "What are the fees?",
  "How to view my bookings?",
  "How to change my password?",
];

function App() {
  const [view, setView] = useState("initial");
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hello! I'm your AI Assistant — a smart, conversational system designed to help you access information, resolve queries, and guide you with accurate insights. To get started, please choose one of the following options: Registered User or Help Desk. Once selected, I'll walk you through the next steps and assist you instantly."
    }
  ]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);
  const abortControllerRef = useRef(null);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authMethod, setAuthMethod] = useState("");
  const [userId, setUserId] = useState("");
  const [userType, setUserType] = useState("");
  const [chatInput, setChatInput] = useState("");
  const [token, setToken] = useState("");
  const [interactionMode, setInteractionMode] = useState("help");
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketCategory, setTicketCategory] = useState("");
  const [ticketSubject, setTicketSubject] = useState("");
  const [ticketMessage, setTicketMessage] = useState("");
  const [ticketSubmitting, setTicketSubmitting] = useState(false);
  const [ticketEmail, setTicketEmail] = useState("");
  const [ticketVoiceActive, setTicketVoiceActive] = useState(false);
  const [ticketCategories, setTicketCategories] = useState([]);
  const [ticketCategoriesLoading, setTicketCategoriesLoading] = useState(false);
  const [customQueryActive, setCustomQueryActive] = useState(false);
  const [chatVoiceActive, setChatVoiceActive] = useState(false);
  const [showTimesheetModal, setShowTimesheetModal] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [timesheetForm, setTimesheetForm] = useState({
    event_id: "",
    name: "",
    arrival_Time: "",
    arrival_am_pm: "am",
    event_start_hr: "",
    event_start_min: "",
    am_pm: "am",
    event_end_hr: "",
    event_end_min: "",
    am_pm2: "pm",
    wait_time: "",
    event_out_come_id: "1",
    travel_time: "",
    total_mileage_covered: "",
    attachment_filename: "",
    timesheet_attachment: "",
  });
  const [timesheetSubmitting, setTimesheetSubmitting] = useState(false);
  const ticketRecognitionRef = useRef(null);
  const chatRecognitionRef = useRef(null);
  // Load from localStorage on mount
  useEffect(() => {
    const savedView = localStorage.getItem(STORAGE_KEYS.VIEW);
    const savedMode = localStorage.getItem(STORAGE_KEYS.MODE);
    if (savedMode) {
      setInteractionMode(savedMode);
    }

    const restoreHelpDeskState = () => {
      try {
        const savedState = localStorage.getItem(STORAGE_KEYS.HELP_DESK);
        if (savedState) {
          console.log("📂 Restoring Help Desk session...");
          const state = JSON.parse(savedState);
          setView("helpDesk");
          setMessages(state.messages || []);
          setChatInput(state.chatInput || "");
          setInput(state.input || "");
          if (state.mode) {
            setInteractionMode(state.mode);
          }
        } else {
          setView("helpDesk");
        }
      } catch (error) {
        console.error("Error loading Help Desk state:", error);
      }
    };

    const restoreRegisteredSession = () => {
      try {
        const savedSession = localStorage.getItem(STORAGE_KEYS.SESSION);
        const savedToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
        const savedEmail = localStorage.getItem(STORAGE_KEYS.EMAIL);

        if (savedSession) {
          console.log("📂 Restoring registered session...");
          const session = JSON.parse(savedSession);
          setView(session.view || "registeredUser");
          setMessages(session.messages || []);
          setChatInput(session.chatInput || "");
          setInput(session.input || "");
          const sessionToken = session.token || savedToken || "";
          if (sessionToken) {
            setToken(sessionToken);
            setEmail(session.email || savedEmail || "");
            setUserId(session.userId || "");
            setUserType(session.userType || "");
            const restoredLoggedIn = session.loggedIn ?? true;
            setLoggedIn(restoredLoggedIn);
            setCustomQueryActive(false);
          }
          if (session.mode) {
            setInteractionMode(session.mode);
          }
        } else if (savedToken) {
          console.log("📂 Found token in storage, restoring basic session...");
          setView("registeredUser");
          setToken(savedToken);
          setEmail(savedEmail || "");
          setLoggedIn(true);
          setCustomQueryActive(false);
        }
      } catch (error) {
        console.error("Error loading registered session:", error);
      }
    };

    if (savedView === "helpDesk") {
      restoreHelpDeskState();
    } else {
      restoreRegisteredSession();
    }
  }, []);

  useEffect(() => {
    if (view === "helpDesk") {
      const helpDeskState = {
        view: "helpDesk",
        messages,
        chatInput,
        input,
        mode: interactionMode,
      };
      localStorage.setItem(STORAGE_KEYS.HELP_DESK, JSON.stringify(helpDeskState));
      localStorage.setItem(STORAGE_KEYS.VIEW, "helpDesk");
    } else if (loggedIn && token) {
      const sessionState = {
        view,
        messages,
        chatInput,
        input,
        token,
        email,
        userId,
        userType,
        loggedIn: true,
        mode: interactionMode,
      };
      localStorage.setItem(STORAGE_KEYS.SESSION, JSON.stringify(sessionState));
      localStorage.setItem(STORAGE_KEYS.TOKEN, token);
      if (email) {
        localStorage.setItem(STORAGE_KEYS.EMAIL, email);
      }
      localStorage.setItem(STORAGE_KEYS.VIEW, view);
    } else {
      localStorage.setItem(STORAGE_KEYS.VIEW, view);
    }
    localStorage.setItem(STORAGE_KEYS.MODE, interactionMode);
  }, [view, messages, chatInput, input, loggedIn, token, email, userId, userType, interactionMode]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  const pushMessages = useCallback((newMessages) => {
    if (!newMessages) return;
    const messagesArray = Array.isArray(newMessages) ? newMessages : [newMessages];
    setMessages((prev) => [...prev, ...messagesArray]);
  }, []);

  const [showPastEventsOptions, setShowPastEventsOptions] = useState(false);
  const [showCustomDateInput, setShowCustomDateInput] = useState(false);
  const [customDateFrom, setCustomDateFrom] = useState("");
  const [customDateTo, setCustomDateTo] = useState("");
  const [modeButtonsDisabled, setModeButtonsDisabled] = useState(false);
  const [authButtonsDisabled, setAuthButtonsDisabled] = useState(false);
  const [micPermissionGranted, setMicPermissionGranted] = useState(false);
  const [micPermissionDenied, setMicPermissionDenied] = useState(false);
  const inputRef = useRef("");
  const chatInputRef = useRef("");
  const inputElementRef = useRef(null);
  const chatInputElementRef = useRef(null);

  useEffect(() => {
    inputRef.current = input;
  }, [input]);

  useEffect(() => {
    chatInputRef.current = chatInput;
  }, [chatInput]);

  const ensureMicrophonePermission = useCallback(async () => {
    if (micPermissionGranted) {
      return true;
    }

    if (typeof navigator === "undefined") {
      throw new Error("Microphone access is not supported on this device/browser.");
    }

    const legacyGetUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;

    const requestAudioStream = () => {
      if (navigator.mediaDevices?.getUserMedia) {
        return navigator.mediaDevices.getUserMedia({ audio: true });
      }
      if (legacyGetUserMedia) {
        return new Promise((resolve, reject) => {
          legacyGetUserMedia.call(navigator, { audio: true }, resolve, reject);
        });
      }
      return null;
    };

    const audioPromise = requestAudioStream();

    if (!audioPromise) {
      console.warn("Microphone stream API not available in this browser; falling back to SpeechRecognition permission prompt.");
      setMicPermissionGranted(true);
      setMicPermissionDenied(false);
      return true;
    }

    try {
      const stream = await audioPromise;
      stream.getTracks().forEach((track) => track.stop());
      setMicPermissionGranted(true);
      setMicPermissionDenied(false);
      return true;
    } catch (error) {
      setMicPermissionDenied(true);

      if (error.name === "NotAllowedError" || error.name === "SecurityError") {
        throw new Error("Microphone permission denied. Please allow microphone access in your browser settings and try again.");
      }

      if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
        throw new Error("No microphone was found. Please connect a microphone and try again.");
      }

      if (typeof window !== "undefined" && !window.isSecureContext) {
        const host = window.location?.hostname || "";
        const isLocalHost = ["localhost", "127.0.0.1", "::1"].includes(host);
        if (!isLocalHost) {
          throw new Error("Microphone access requires a secure (HTTPS) connection when running on a public network address. Please access this app via HTTPS (or use localhost) and try again.");
        }
      }

      throw new Error("Unable to access microphone. Please ensure no other app is using it and try again.");
    }
  }, [micPermissionGranted]);

  // Get suggestion list based on context
  const getSuggestionList = useCallback(() => {
    if (view === "helpDesk") {
      return HELP_DESK_QUERY_SUGGESTIONS;
    }

    if (!loggedIn || !userType) {
      return [];
    }

    const isCustomer = userType === "contact";
    const isAppointmentMode = interactionMode === "appointment";

    if (isAppointmentMode) {
      return isCustomer
        ? CUSTOM_QUERY_EXAMPLES_APPOINTMENT_CUSTOMER.slice(0, 5)
        : CUSTOM_QUERY_EXAMPLES_APPOINTMENT_INTERPRETER.slice(0, 5);
    } else {
      return isCustomer
        ? CUSTOM_QUERY_EXAMPLES_HELP_CUSTOMER.slice(0, 5)
        : CUSTOM_QUERY_EXAMPLES_HELP_INTERPRETER.slice(0, 5);
    }
  }, [view, loggedIn, userType, interactionMode]);

  // Filter suggestions based on input
  const filterSuggestions = useCallback((inputText) => {
    if (!inputText || inputText.trim().length === 0) {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const suggestionList = getSuggestionList();
    const searchText = inputText.toLowerCase().trim();

    const filtered = suggestionList.filter((suggestion) => {
      const suggestionText = typeof suggestion === "string" ? suggestion : suggestion.label;
      return suggestionText.toLowerCase().includes(searchText);
    });

    setFilteredSuggestions(filtered.slice(0, 5)); // Limit to 5 suggestions
    setShowSuggestions(filtered.length > 0);
  }, [getSuggestionList]);

  // Update filtered suggestions when input changes
  useEffect(() => {
    // Disable suggestions in appointment mode
    if (interactionMode === "appointment") {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    if (view === "helpDesk" || (loggedIn && customQueryActive)) {
      const currentInput = view === "helpDesk" ? input : chatInput;
      filterSuggestions(currentInput);
    } else {
      setFilteredSuggestions([]);
      setShowSuggestions(false);
    }
  }, [input, chatInput, view, loggedIn, customQueryActive, interactionMode, filterSuggestions]);

  const handleCustomQueryActivate = useCallback(() => {
    setModeButtonsDisabled(false);
    pushMessages({
      sender: "bot",
      text: "Please choose how you'd like to use the assistant:",
      buttons: [
        { key: "mode_help", label: "Help Mode" },
        { key: "mode_appointment", label: "Appointment Mode" },
        { key: "cancel_custom_query", label: "Cancel" },
      ],
    });
  }, [pushMessages]);
  const handleCustomQueryModeSelect = useCallback((modeKey) => {
    setModeButtonsDisabled(true);

    const selectedMode = modeKey === "mode_appointment" ? "appointment" : "help";
    setInteractionMode(selectedMode);
    setCustomQueryActive(true);

    const isCustomer = userType === "contact";
    const suggestionsList = (() => {
      if (selectedMode === "appointment") {
        return isCustomer
          ? CUSTOM_QUERY_EXAMPLES_APPOINTMENT_CUSTOMER.slice(0, 5)
          : CUSTOM_QUERY_EXAMPLES_APPOINTMENT_INTERPRETER.slice(0, 5);
      }
      return isCustomer
        ? CUSTOM_QUERY_EXAMPLES_HELP_CUSTOMER.slice(0, 5)
        : CUSTOM_QUERY_EXAMPLES_HELP_INTERPRETER.slice(0, 5);
    })();

    const suggestions = suggestionsList
      .map((example) => `• ${example}`)
      .join("<br>");

    pushMessages({
      sender: "bot",
      text: `
        <div style="
          padding: 18px; 
          border-radius: 12px;
          font-family: 'Segoe UI', sans-serif;
          line-height: 1.7;
          border-left: 4px solid #4a90e2;
        ">
          <div style="font-size: 20px; font-weight: 700; margin-bottom: 10px;">
            🧠 ${selectedMode === "help" ? "Help Mode Enabled" : "Appointment Mode Enabled"}
          </div>
          <div style="font-size: 15px; margin-bottom: 14px;">
            I'm here to help. What would you like to do?
          </div>
          <div style="font-weight: 600; margin-bottom: 6px;">Try asking me:</div>
          <div>${suggestions}</div>
        </div>
      `,
    });

  }, [pushMessages, userType]);

  const stopChatVoiceCapture = useCallback(() => {
    if (chatRecognitionRef.current) {
      chatRecognitionRef.current.onresult = null;
      chatRecognitionRef.current.onerror = null;
      try {
        chatRecognitionRef.current.stop();
      } catch (error) {
        console.warn("Chat voice stop error:", error);
      }
      chatRecognitionRef.current = null;
    }
    setChatVoiceActive(false);
  }, []);

  const handleTokenExpiration = useCallback(() => {
    console.log("🔒 Token expired, clearing session...");

    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.EMAIL);
    localStorage.removeItem(STORAGE_KEYS.SESSION);
    localStorage.removeItem(STORAGE_KEYS.VIEW);
    localStorage.removeItem(STORAGE_KEYS.MODE);

    setLoggedIn(false);
    setToken("");
    setEmail("");
    setUserId("");
    setUserType("");
    setChatInput("");
    setView("registeredUser");
    setCustomQueryActive(false);
    setModeButtonsDisabled(false);
    setAuthButtonsDisabled(false);
    stopChatVoiceCapture();
    setShowTimesheetModal(false);
    setTimesheetSubmitting(false);

    pushMessages({
      sender: "bot",
      text: "🔒 Your session has expired. Please login again to continue.",
    });

    setMessages([
      { sender: "bot", text: "Please enter your email to continue." }
    ]);
  }, [pushMessages, stopChatVoiceCapture]);

  const sendHelpDeskQuery = useCallback(async (queryText) => {
    const trimmed = queryText.trim();
    if (!trimmed) return;

    pushMessages({ sender: "user", text: trimmed });
    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log("💬 Sending help desk query...");
      const response = await fetch(`${API_BASE_URL}/generalquery`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          question: trimmed,
          mode: "general",
          context: "General support for interpreter platform users.",
        }),
        signal: abortControllerRef.current.signal,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Unable to process your query right now.");
      }

      pushMessages({ sender: "bot", text: data.response });
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }
      console.error("❌ Query Error:", error.message);
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to process your query right now."}`,
      });
    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  }, [pushMessages]);

  const submitUserQuery = useCallback(async (queryText) => {
    const trimmed = queryText.trim();
    if (!trimmed) return;

    if (!loggedIn) {
      pushMessages({
        sender: "bot",
        text: "❌ Please login first to ask questions.",
      });
      return;
    }

    const sanitizedEmail = email.trim();
    if (!sanitizedEmail) {
      pushMessages({
        sender: "bot",
        text: "❌ Please login with your email.",
      });
      return;
    }

    pushMessages({ sender: "user", text: trimmed });
    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      const endpointMap = {
        vendor: "/interpreterresponse",
        contact: "/customerresponse",
      };
      const endpoint = endpointMap[userType] || "/interpreterresponse";

      console.log(`💬 Sending ${userType} query to ${endpoint}...`);
      // console.log('====================')
      // console.log('user id is', userId);
      // console.log('====================')
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          email: sanitizedEmail,
          question: trimmed,
          user_id: userId,
          mode: interactionMode,
        }),
        signal: abortControllerRef.current.signal,
      });

      const data = await response.json();

      // Check for token expiration
      if (response.status === 403 && (data.type === "access_token" || data.message?.includes("token") || data.message?.includes("expired"))) {
        handleTokenExpiration();
        return;
      }

      if (!response.ok) {
        throw new Error(data.error || "Unable to process your request right now.");
      }

      pushMessages({ sender: "bot", text: data.response });
    } catch (error) {
      if (error.name === "AbortError") {
        return;
      }
      console.error("❌ Query Error:", error.message);
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to process your request right now."}`,
      });
    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  }, [email, handleTokenExpiration, interactionMode, loggedIn, pushMessages, token, userType, userId]);

  const handleChatVoiceToggle = useCallback(async () => {
    if (chatVoiceActive) {
      stopChatVoiceCapture();
      return;
    }

    try {
      await ensureMicrophonePermission();
    } catch (permissionError) {
      pushMessages({
        sender: "bot",
        text: `❌ ${permissionError.message}`,
      });
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      pushMessages({
        sender: "bot",
        text: "❌ Voice input is not supported in this browser.",
      });
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = (event.results[0][0].transcript || "").trim();
      if (!transcript) return;

      if (view === "helpDesk") {
        const base = (inputRef.current || "").trim();
        const combined = base ? `${base} ${transcript}` : transcript;
        setInput("");
        sendHelpDeskQuery(combined);
      } else if (loggedIn) {
        const base = (chatInputRef.current || "").trim();
        const combined = base ? `${base} ${transcript}` : transcript;
        setChatInput("");
        submitUserQuery(combined);
      } else {
        setChatInput((prev) => (prev ? `${prev} ${transcript}` : transcript));
      }
    };

    recognition.onerror = (event) => {
      console.error("Chat voice input error:", event.error);
      pushMessages({
        sender: "bot",
        text: "❌ Unable to capture voice input. Please try again.",
      });
      stopChatVoiceCapture();
    };

    recognition.onend = () => {
      setChatVoiceActive(false);
      chatRecognitionRef.current = null;
    };

    try {
      recognition.start();
      chatRecognitionRef.current = recognition;
      setChatVoiceActive(true);
    } catch (error) {
      console.error("Chat voice start error:", error);
      pushMessages({
        sender: "bot",
        text: "❌ Unable to start voice input. Please try again.",
      });
    }
  }, [chatVoiceActive, ensureMicrophonePermission, loggedIn, pushMessages, sendHelpDeskQuery, stopChatVoiceCapture, submitUserQuery, view]);
  useEffect(() => {
    return () => {
      stopChatVoiceCapture();
    };
  }, [stopChatVoiceCapture]);

  const handleCustomQueryDeactivate = useCallback(() => {
    stopChatVoiceCapture();
    setModeButtonsDisabled(true);
    setCustomQueryActive(false);
    setInteractionMode("help");
    pushMessages({
      sender: "bot",
      text: "ℹ️ Ask Query Mode disabled. Select <strong>Ask Query</strong> to enable it again.",
    });
  }, [pushMessages, stopChatVoiceCapture]);


  const openTimesheetModal = useCallback((eventData) => {
    setTimesheetForm((prev) => ({
      ...prev,
      event_id: eventData?.event_id || "",
      name: eventData?.name || "",
    }));
    setShowTimesheetModal(true);
  }, []);

  const closeTimesheetModal = () => {
    if (timesheetSubmitting) return;
    setShowTimesheetModal(false);
    setTimesheetForm((prev) => ({
      ...prev,
      event_id: "",
      name: "",
      arrival_Time: "",
      arrival_am_pm: "am",
      event_start_hr: "",
      event_start_min: "",
      am_pm: "am",
      event_end_hr: "",
      event_end_min: "",
      am_pm2: "pm",
      wait_time: "",
      event_out_come_id: "1",
      travel_time: "",
      total_mileage_covered: "",
      timesheet_attachment: "",
      attachment_filename: "",
    }));
  };

  const handleTimesheetInputChange = (field, value) => {
    setTimesheetForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const fetchEventDetails = useCallback(async (eventId) => {
    if (!loggedIn || !token) {
      pushMessages({
        sender: "bot",
        text: "❌ Authentication token is missing. Please login again.",
      });
      return;
    }

    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log(`📡 Fetching event details for event_id: ${eventId}`);

      const trimmedToken = token.trim();
      const isContactUser = userType === "contact";
      const namespace = isContactUser ? "customer" : "interpreter";

      const formdata = new FormData();
      formdata.append("access_token", trimmedToken);
      formdata.append("event_id", eventId);

      const endpoint = `${API_BASE_URL1}/api/${namespace}/get/event_details`;

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: abortControllerRef.current.signal,
      };

      const response = await fetch(endpoint, requestOptions);
      const text = await response.text();
      console.log("Event Details API Response:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        console.error("JSON Parse Error:", parseError);
        throw new Error("Invalid response format from server. Please try again.");
      }

      // Check for token expiration
      if (response.status === 403 && (data.type === "access_token" || data.message?.includes("token") || data.message?.includes("expired"))) {
        handleTokenExpiration();
        return;
      }

      if (!response.ok || (data.status === false)) {
        const errorMessage = data.error || data.message || data.msg || `HTTP ${response.status}: Unable to fetch event details.`;
        throw new Error(errorMessage);
      }

      // Helper function to format date from YYYYDDMM to MM/DD/YYYY
      const formatDate = (dateString) => {
        if (!dateString) return "";
        try {
          // Check if it's in YYYYDDMM format (8 digits, no separators)
          const dateMatch = dateString.match(/^(\d{4})(\d{2})(\d{2})$/);
          if (dateMatch) {
            const [, year, day, month] = dateMatch;
            return `${month}/${day}/${year}`;
          }
          // Check if it's in YYYY-MM-DD format (with separators)
          const dateMatchWithSeparators = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (dateMatchWithSeparators) {
            const [, year, month, day] = dateMatchWithSeparators;
            return `${month}/${day}/${year}`;
          }
          // If already formatted or different format, return as is
          return dateString;
        } catch (error) {
          return dateString;
        }
      };

      // Format and display the response
      let formattedResponse = "";

      if (data.event_data || (data.status && data.data)) {
        const eventDetails = data.event_data || data.data;

        formattedResponse = `<strong>📋 Event Details</strong><br><br>`;
        formattedResponse += `<div style="background: #ffffff; border: 1.5px solid #cbd5e1; padding: 16px; border-radius: 8px; margin-bottom: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">`;

        // Group fields into logical sections
        const sections = {
          "Basic Information": [
            { key: "name", label: "Event#" },
            { key: "state_name", label: "Status" },
            { key: "event_type", label: "Event Type" },
            { key: "event_schedule_type", label: "Schedule Type" },
          ],
          "Date & Time": [
            { key: "event_start_date", label: "Start Date", isDate: true },
            { key: "event_start_time", label: "Start Time" },
            { key: "event_end_time", label: "End Time" },
            { key: "customer_timezone", label: "Timezone" },
          ],
          "Interpretation Details": [
            { key: "interpretation_type", label: "Interpretation Type" },
            { key: "language_name", label: "Language" },
            { key: "interpreter_note", label: "Interpreter Notes" },
          ],
          "Location & Contact": [
            { key: "location_formatted", label: "Location" },
            { key: "meeting_location_zip", label: "Zip Code" },
            { key: "meeting_phone", label: "Phone" },
            { key: "meeting_note", label: "Meeting Notes" },
          ],
          "Additional Information": [
            { key: "patient_name", label: "Patient Name" },
            { key: "doctor_name", label: "Doctor Name" },
            { key: "project_name", label: "Project Name" },
            { key: "ref", label: "Reference" },
            { key: "invoice_number", label: "Invoice Number" },
            { key: "check_no", label: "Check Number" },
            { key: "check_amount", label: "Check Amount" },
          ],
        };

        // Format each section
        Object.keys(sections).forEach((sectionName) => {
          const fields = sections[sectionName];
          let hasData = false;
          let sectionHtml = "";

          fields.forEach((field) => {
            let value = eventDetails[field.key];
            if (value !== null && value !== undefined && value !== "") {
              hasData = true;
              // Format date if it's a date field
              if (field.isDate) {
                value = formatDate(value);
              }
              sectionHtml += `<div style="margin-bottom: 8px;"><strong style="color: #1e5ba8;">${field.label}:</strong> <span style="color: #333;">${value}</span></div>`;
            }
          });

          if (hasData) {
            formattedResponse += `<div style="margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid #e0e0e0;">`;
            formattedResponse += `<h3 style="margin: 0 0 12px 0; font-size: 14px; color: #1e5ba8; font-weight: 600;">${sectionName}</h3>`;
            formattedResponse += sectionHtml;
            formattedResponse += `</div>`;
          }
        });

        formattedResponse += `</div>`;
      } else if (data.msg) {
        formattedResponse = `✅ ${data.msg}`;
        if (data.event_data) {
          formattedResponse += `<br><br>Event details are available.`;
        }
      } else if (data.message) {
        formattedResponse = data.message;
      } else {
        formattedResponse = `Event details:<br><br>${JSON.stringify(data, null, 2).replace(/\n/g, '<br>')}`;
      }

      pushMessages({
        sender: "bot",
        text: formattedResponse,
      });

    } catch (error) {
      if (error.name === "AbortError") return;

      console.error("❌ Event Details API Error:", error.message);
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to fetch event details. Please try again."}`,
      });

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  }, [loggedIn, token, userType, pushMessages, setLoading, handleTokenExpiration]);

  const handleTimesheetFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      handleTimesheetInputChange("attachment_filename", "");
      handleTimesheetInputChange("timesheet_attachment", "");
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      handleTimesheetInputChange("attachment_filename", file.name);
      handleTimesheetInputChange("timesheet_attachment", reader.result || "");
    };
    reader.readAsDataURL(file);
  };

  const handleTimesheetSubmit = async () => {
    if (!token) {
      pushMessages({
        sender: "bot",
        text: "❌ Authentication token missing. Please login again.",
      });
      return;
    }

    if (!timesheetForm.event_id) {
      pushMessages({
        sender: "bot",
        text: "❌ Event information missing. Please select an event again.",
      });
      return;
    }

    setTimesheetSubmitting(true);
    try {
      const formdata = new FormData();
      formdata.append("access_token", token.trim());
      Object.entries(timesheetForm).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formdata.append(key, value);
        }
      });

      const response = await fetch(`${API_BASE_URL1}/api/interpreter/enter_timesheet`, {
        method: "POST",
        body: formdata,
        redirect: "follow",
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid response format from server.");
      }

      if (!response.ok || data.status === false) {
        throw new Error(data.msg || data.message || data.error || "Unable to submit timesheet.");
      }

      pushMessages({
        sender: "bot",
        text: data.msg || "✅ Timesheet submitted successfully!",
      });
      closeTimesheetModal();
    } catch (error) {
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to submit timesheet. Please try again."}`,
      });
    } finally {
      setTimesheetSubmitting(false);
    }
  };

  const handleJobAction = useCallback(async (actionUrl, actionType) => {
    if (!actionUrl) {
      pushMessages({
        sender: "bot",
        text: `❌ ${actionType} URL is not available.`,
      });
      return;
    }

    // Decode HTML entities
    let decodedUrl = actionUrl
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');

    // Convert http to https to avoid CORS issues
    if (decodedUrl.startsWith('http://')) {
      decodedUrl = decodedUrl.replace('http://', 'https://');
      console.log(`📡 Converted http to https: ${decodedUrl}`);
    }

    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log(`📡 Fetching URL: ${decodedUrl}`);

      // Validate URL before fetching
      let finalUrl = decodedUrl;
      try {
        const urlObj = new URL(decodedUrl);
        finalUrl = urlObj.href;
        console.log(`📡 Valid URL: ${finalUrl}`);
      } catch (urlError) {
        console.error(`❌ Invalid URL format:`, decodedUrl);
        pushMessages({
          sender: "bot",
          text: `❌ Invalid URL format.`,
        });
        return;
      }

      // Simple GET request - no credentials needed (URL already has access_token)
      const response = await fetch(finalUrl, {
        redirect: "follow",
        signal: abortControllerRef.current.signal,
      });

      console.log(`📡 Response status: ${response.status} ${response.statusText}`);
      console.log(`📡 Response headers:`, [...response.headers.entries()]);

      const text = await response.text();
      console.log(`📡 Response text:`, text);

      let data;

      try {
        data = JSON.parse(text);
        console.log(`📡 Parsed data:`, data);
      } catch (parseError) {
        console.error(`❌ JSON parse error:`, parseError);
        pushMessages({
          sender: "bot",
          text: text || `Response received from server.`,
        });
        return;
      }

      // Handle response message - check for description array
      let message = data.msg || data.message || "";

      // If there's a description array, format it
      if (data.description && Array.isArray(data.description)) {
        const descriptions = data.description.filter(desc => desc && desc.trim() !== "");
        if (descriptions.length > 0) {
          message = message ? `${message}<br><br>` : "";
          descriptions.forEach((desc, index) => {
            message += desc;
            if (index < descriptions.length - 1) {
              message += "<br>";
            }
          });
        }
      }

      // If no message, show the full response
      if (!message) {
        message = JSON.stringify(data);
      }

      pushMessages({
        sender: "bot",
        text: message,
      });

    } catch (error) {
      if (error.name === "AbortError") return;

      console.error(`❌ Fetch error:`, error);
      console.error(`❌ Error name:`, error.name);
      console.error(`❌ Error message:`, error.message);
      console.error(`❌ Error stack:`, error.stack);

      let errorMessage = error.message || `Unable to ${actionType.toLowerCase()} job. Please try again.`;

      // Provide more specific error messages
      if (error.name === "TypeError" && error.message.includes("Failed to fetch")) {
        errorMessage = `Network error: Unable to connect to the server. Please check your connection.`;
      } else if (error.message.includes("CORS")) {
        errorMessage = `CORS error: ${error.message}. Please check server CORS configuration.`;
      }

      pushMessages({
        sender: "bot",
        text: `❌ ${errorMessage}`,
      });

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  }, [pushMessages, setLoading]);

  // Attach click listeners to event name links and action buttons
  useEffect(() => {
    const handleEventNameClick = (event) => {
      const eventId = event.target.getAttribute('data-event-id');
      if (eventId) {
        fetchEventDetails(eventId);
      }
    };

    const handleJobActionClick = (event) => {
      event.preventDefault(); // Prevent default anchor navigation
      const link = event.target.closest('.job-action-btn') || event.target;
      const actionUrl = link.getAttribute('href') || link.getAttribute('data-action-url');
      const actionType = link.getAttribute('data-action-type');

      if (actionUrl && actionType) {
        handleJobAction(actionUrl, actionType);
      }
    };

    const handleTimesheetButtonClick = (event) => {
      event.preventDefault();
      const link = event.target.closest('.fill-timesheet-btn') || event.target;
      const eventDataAttr = link.getAttribute('data-event');
      if (!eventDataAttr) return;
      try {
        const eventData = JSON.parse(decodeURIComponent(eventDataAttr));
        openTimesheetModal(eventData);
      } catch (err) {
        console.error("❌ Unable to parse event data for timesheet:", err);
        pushMessages({
          sender: "bot",
          text: "❌ Unable to open timesheet form. Please try again.",
        });
      }
    };

    // Use a small delay to ensure DOM is updated after messages render
    const timeoutId = setTimeout(() => {
      const eventNameLinks = document.querySelectorAll('.event-name-link');
      eventNameLinks.forEach((link) => {
        link.addEventListener('click', handleEventNameClick);
      });

      const jobActionButtons = document.querySelectorAll('.job-action-btn');
      jobActionButtons.forEach((button) => {
        if (button.classList.contains('fill-timesheet-btn')) {
          button.addEventListener('click', handleTimesheetButtonClick);
        } else {
          button.addEventListener('click', handleJobActionClick);
        }
      });
    }, 100);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      const eventNameLinks = document.querySelectorAll('.event-name-link');
      eventNameLinks.forEach((link) => {
        link.removeEventListener('click', handleEventNameClick);
      });

      const jobActionButtons = document.querySelectorAll('.job-action-btn');
      jobActionButtons.forEach((button) => {
        button.removeEventListener('click', handleJobActionClick);
        button.removeEventListener('click', handleTimesheetButtonClick);
      });
    };
  }, [messages, fetchEventDetails, handleJobAction, pushMessages, openTimesheetModal]);

  const renderEventsTable = (events = [], title = "Events") => {
    if (!Array.isArray(events) || events.length === 0) {
      return `No events found for ${title}.`;
    }

    // Helper function to format date from YYYYDDMM to MM/DD/YYYY
    const formatDate = (dateString) => {
      if (!dateString) return "";
      try {
        // Check if it's in YYYYDDMM format (8 digits, no separators)
        const dateMatch = dateString.match(/^(\d{4})(\d{2})(\d{2})$/);
        if (dateMatch) {
          const [, year, day, month] = dateMatch;
          return `${month}/${day}/${year}`;
        }
        // Check if it's in YYYY-MM-DD format (with separators)
        const dateMatchWithSeparators = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (dateMatchWithSeparators) {
          const [, year, month, day] = dateMatchWithSeparators;
          return `${month}/${day}/${year}`;
        }
        // If already formatted or different format, return as is
        return dateString;
      } catch (error) {
        return dateString;
      }
    };

    // Helper function to get the actual value for a column
    const getColumnValue = (event, columnKey, eventIndex) => {
      if (columnKey === "name") {
        // For interpreter and customer: use name field
        return event.name || `#${eventIndex + 1}`;
      } else if (columnKey === "event_start_date") {
        // Use event_start_date and format it
        if (event.event_start_date) {
          return formatDate(event.event_start_date);
        }
        return null;
      } else if (columnKey === "event_start_time") {
        // Use event_start_time
        return event.event_start_time || null;
      } else if (columnKey === "event_end_time") {
        // Use event_end_time
        return event.event_end_time || null;
      } else if (columnKey === "timezone") {
        return event.customer_timezone || null;
      } else if (columnKey === "language") {
        return event.language_name || null;
      } else if (columnKey === "location") {
        // For interpreter: use location_complete_name, for customer: check if available
        return event.location_complete_name || null;
      } else if (columnKey === "status") {
        return event.state_name || null;
      }
      return null;
    };

    // Helper to check if value is empty
    const isEmpty = (value) => {
      return value === null || value === undefined || value === "" || value === "—";
    };

    // Define all possible columns in the exact order specified
    const allColumns = [
      { key: "name", label: "Event#" },
      { key: "event_start_date", label: "Start Date" },
      { key: "event_start_time", label: "Start Time" },
      { key: "event_end_time", label: "End Time" },
      { key: "timezone", label: "Timezone" },
      { key: "language", label: "Language" },
      { key: "location", label: "Location" },
      { key: "status", label: "Status" },
    ];

    // Add Actions column if it's Job Offered Events or Pending Timesheet Events
    const isJobOffered = title === "Job Offered Events";

    // Filter out status column for Job Offered Events
    const columnsToUse = isJobOffered
      ? allColumns.filter(column => column.key !== "status")
      : allColumns;

    // Check which columns have at least one non-empty value
    const columnsWithData = columnsToUse.filter((column) => {
      if (column.key === "name") {
        // Event# should always be shown (has fallback)
        return true;
      }
      return events.some((event, index) => {
        const value = getColumnValue(event, column.key, index);
        return !isEmpty(value);
      });
    });
    const isPendingTimesheet = title === "Pending Timesheet Events";
    if (isJobOffered) {
      // Check if any event has action URLs
      const hasActions = events.some(event => event.accept_url || event.reject_url);
      if (hasActions) {
        columnsWithData.push({ key: 'actions', label: 'Actions' });
      }
    } else if (isPendingTimesheet) {
      // Always add Actions column for Pending Timesheet Events
      columnsWithData.push({ key: 'actions', label: 'Actions' });
    }

    const formatValue = (value) => (isEmpty(value) ? "—" : String(value));

    let cardsHtml = `<strong>${title}</strong><br/><br/>`;
    cardsHtml += `<div class="events-cards-wrapper" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 16px; margin-top: 16px;">`;

    events.forEach((event, eventIndex) => {
      cardsHtml += `<div class="event-card" style="background: #ffffff; border: 1.5px solid #cbd5e1; padding: 16px; border-radius: 8px; margin-bottom: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">`;

      columnsWithData.forEach((column) => {
        if (column.key === "actions") {
          cardsHtml += `<div style="margin-top: 12px; padding-top: 12px; border-top: 1px solid #e0e0e0; text-align: center;">`;

          if (isPendingTimesheet) {
            // Render Fill Timesheet button for Pending Timesheet Events
            const eventPayload = encodeURIComponent(JSON.stringify({
              event_id: event.event_id || event.id || "",
              name: event.name || ""
            }));
            cardsHtml += `<a href="#" class="job-action-btn fill-timesheet-btn" data-event='${eventPayload}' style="color:#1e5ba8; text-decoration:underline; font-weight:600; display: inline-block; padding: 8px 16px; background: #e9f1ff; border-radius: 6px;">Fill Timesheet</a>`;
          } else if (isJobOffered) {
            // Render Accept/Reject buttons for Job Offered Events
            const acceptUrl = event.accept_url || "";
            const rejectUrl = event.reject_url || "";
            if (acceptUrl) {
              cardsHtml += `<a href="${acceptUrl}" class="job-action-btn accept-btn" data-action-url="${acceptUrl}" data-action-type="Accept" style="color: #28a745; text-decoration: underline; margin-right: 8px; font-size: 13px; cursor: pointer; padding: 6px 12px; background: #d4edda; border-radius: 6px; display: inline-block;">Accept</a>`;
            }
            if (rejectUrl) {
              cardsHtml += `<a href="${rejectUrl}" class="job-action-btn reject-btn" data-action-url="${rejectUrl}" data-action-type="Reject" style="color: #dc3545; text-decoration: underline; font-size: 13px; cursor: pointer; padding: 6px 12px; background: #f8d7da; border-radius: 6px; display: inline-block;">Reject</a>`;
            }
            if (!acceptUrl && !rejectUrl) {
              cardsHtml += `<span style="color: #999;">—</span>`;
            }
          } else {
            cardsHtml += `<span style="color: #999;">—</span>`;
          }

          cardsHtml += `</div>`;
        } else {
          const rawValue = getColumnValue(event, column.key, eventIndex);
          const value = formatValue(rawValue);

          if (column.key === "name") {
            // Make it clickable - use event_id if available, otherwise use name
            const clickableEventId = event.event_id || event.id || rawValue;
            cardsHtml += `<div style="margin-bottom: 8px;"><strong style="color: #1e5ba8;">${column.label}:</strong> <span class="event-name-link" data-event-id="${clickableEventId}" data-event-index="${eventIndex}" style="color: #1e5ba8; cursor: pointer; text-decoration: underline;">${value}</span></div>`;
          } else {
            cardsHtml += `<div style="margin-bottom: 8px;"><strong style="color: #1e5ba8;">${column.label}:</strong> <span style="color: #333;">${value}</span></div>`;
          }
        }
      });

      cardsHtml += `</div>`;
    });

    cardsHtml += `</div>`;
    return cardsHtml;
  };

  const stopLoading = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    setLoading(false);
    pushMessages({
      sender: "bot",
      text: "❌ Request cancelled by user.",
    });
  };

  const sendOTP = async (emailAddress) => {
    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log("📧 Sending OTP to:", emailAddress);

      const formdata = new FormData();
      formdata.append("email", emailAddress);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: abortControllerRef.current.signal,
      };

      const response = await fetch(`https://erp.iugroup.com/api/send_email_otp`, requestOptions);

      const text = await response.text();
      console.log("Raw Response:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid response format from server.");
      }

      // Check for invalid email (404 status or specific message)
      if (response.status === 404 || data.status_code === 404 ||
        data.msg?.toLowerCase().includes("no user found") ||
        data.message?.toLowerCase().includes("no user found")) {
        const errorMsg = data.msg || data.message || "No user found for the provided email address.";
        pushMessages({
          sender: "bot",
          text: `❌ ${errorMsg}. Please check your email address and try again.`,
        });
        // Reset auth method so user can try again
        setAuthMethod("");
        setOtpSent(false);
        return false;
      }

      if (!response.ok || data.status === false) {
        const errorMsg = data.error || data.msg || data.message || "Unable to send OTP. Please try again.";
        throw new Error(errorMsg);
      }

      setOtpSent(true);

      const successMessages = [
        { sender: "bot", text: `✅ ${data.msg}` },

      ];

      if (data.demo_otp) {
        successMessages.push({
          sender: "bot",
          text: `🛠️ Demo OTP: ${data.demo_otp}`,
        });
      }

      pushMessages(successMessages);
      return true;

    } catch (error) {
      if (error.name === "AbortError") {
        return false;
      }

      console.error("❌ OTP Error:", error.message);
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to send OTP. Please try again."}`,
      });
      return false;

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  const verifyOTP = async (emailAddress, userOtp) => {
    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log("🔐 Verifying OTP...");

      const formdata = new FormData();
      formdata.append("email", emailAddress);
      formdata.append("authentication_method", "otp");
      formdata.append("otp", userOtp);
      formdata.append("password", "");

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: abortControllerRef.current.signal,
      };

      const response = await fetch(`https://erp.iugroup.com/api/bot/authentication`, requestOptions);

      const text = await response.text();
      console.log("Raw Response:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid server response format.");
      }

      // Check for authentication failure (401 status or specific message)
      if (response.status === 401 || data.status_code === 401 ||
        data.message?.toLowerCase().includes("authentication failed") ||
        data.type?.toLowerCase().includes("authentication failed")) {
        // const errorMsg = data.message || data.error || "Authentication failed.";
        pushMessages({
          sender: "bot",
          text: `❌ Incorrect credentials. Please verify your email and OTP.`,
        });
        // Reset authentication state
        setAuthMethod("");
        setOtpSent(false);
        setOtp("");
        setEmail("");
        setAuthButtonsDisabled(false);
        return false;
      }

      if (!response.ok || data.status === false) {
        throw new Error(data.error || "Invalid OTP. Please try again.");
      }

      console.log("📦 Full API Response:", data);

      const newToken = data.oauth_access_token || data.token || data.access_token || "";
      console.log("🔑 Token received:", newToken ? `${newToken.substring(0, 20)}...` : "EMPTY");
      console.log("👤 User Type:", data.user_type);
      console.log("🆔 User ID:", data.uid);

      if (!newToken) {
        console.error("⚠️ No token found in response!");
        throw new Error("No authentication token received from server.");
      }

      setToken(newToken);
      setUserId(data.uid);
      setUserType(data.user_type);
      setLoggedIn(true);
      setCustomQueryActive(false);
      setCustomQueryActive(false);
      setAuthMethod("");
      setAuthButtonsDisabled(true);

      localStorage.setItem("chatAppToken", newToken);
      localStorage.setItem("chatAppEmail", emailAddress);

      console.log("✅ OTP Verified successfully");

      pushMessages({
        sender: "bot",
        text: `✅ Login successful. Welcome <strong>${data.name}</strong>; you may now use the options below to access events, or support services.`,
      });

      return true;

    } catch (error) {
      if (error.name === "AbortError") return false;

      console.error("❌ OTP Verification Error:", error.message);

      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Invalid OTP. Please try again."}`,
      });
      setAuthButtonsDisabled(false);

      return false;

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handlePasswordLogin = async () => {
    const trimmedPassword = passwordInput.trim();

    if (!trimmedPassword) {
      pushMessages({ sender: "bot", text: "❌ Please enter your password." });
      return;
    }

    pushMessages({ sender: "user", text: "••••••••" });
    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log("🔐 Password login attempt...");

      const formdata = new FormData();
      formdata.append("email", email.trim());
      formdata.append("authentication_method", "password");
      formdata.append("otp", "");
      formdata.append("password", trimmedPassword);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: abortControllerRef.current.signal,
      };

      const response = await fetch(`https://erp.iugroup.com/api/bot/authentication`, requestOptions);

      const text = await response.text();
      console.log("Raw Response:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Invalid server response format.");
      }

      // Check for authentication failure (401 status or specific message)
      if (response.status === 401 || data.status_code === 401 ||
        data.message?.toLowerCase().includes("authentication failed") ||
        data.type?.toLowerCase().includes("authentication failed")) {
        // const errorMsg = data.message || data.error || "Authentication failed.";
        pushMessages({
          sender: "bot",
          text: `❌ Incorrect credentials. Please verify your email and password.`,
        });
        // Reset authentication state
        setAuthMethod("");
        setPasswordInput("");
        setEmail("");
        setAuthButtonsDisabled(false);
        return;
      }

      if (!response.ok || data.status === false) {
        throw new Error(data.error || "Invalid credentials. Please try again.");
      }

      console.log("📦 Full API Response:", data);

      const newToken = data.oauth_access_token || data.token || data.access_token || "";
      console.log("🔑 Token received:", newToken ? `${newToken.substring(0, 20)}...` : "EMPTY");
      console.log("👤 User Type:", data.user_type);
      console.log("🆔 User ID:", data.uid);

      if (!newToken) {
        console.error("⚠️ No token found in response!");
        throw new Error("No authentication token received from server.");
      }

      setToken(newToken);
      setUserId(data.uid);
      setUserType(data.user_type);
      setLoggedIn(true);
      setAuthMethod("");
      setPasswordInput("");
      setAuthButtonsDisabled(true);

      localStorage.setItem("chatAppToken", newToken);
      localStorage.setItem("chatAppEmail", email.trim());

      console.log("✅ Password login successful");

      pushMessages({
        sender: "bot",
        text: `✅ Login successful. Welcome ${data.name}; you may now use the options below to access events, or support services.`,
      });

    } catch (error) {
      if (error.name === "AbortError") return;

      console.error("❌ Password Login Error:", error.message);

      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Authentication failed. Please try again."}`,
      });
      setAuthButtonsDisabled(false);

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  // NEW: Function to call interpreter-specific APIs
  const callInterpreterAPI = async (actionType, period = "", startDate = "", endDate = "") => {
    // Check if user is logged in
    if (!loggedIn || !token) {
      pushMessages({
        sender: "bot",
        text: "❌ Authentication token is missing. Please login again.",
      });
      return;
    }

    setLoading(true);
    abortControllerRef.current = new AbortController();

    try {
      console.log(`📡 Calling API for: ${actionType}`);
      console.log(`🔑 Using token: ${token ? `${token.substring(0, 20)}...` : "MISSING"}`);

      // Validate token before making request
      if (!token || token.trim() === "") {
        throw new Error("Authentication token is empty. Please login again.");
      }

      const trimmedToken = token.trim();
      const isContactUser = userType === "contact";
      const namespace = isContactUser ? "customer" : "interpreter";
      const formdata = new FormData();
      formdata.append("access_token", trimmedToken);

      let endpoint = "";

      // Determine endpoint and parameters based on action type
      if (actionType === "Job Offered Events") {
        endpoint = `${API_BASE_URL1}/api/${namespace}/get/job_offered_events`;
      } else if (actionType === "Today's Events") {
        endpoint = `${API_BASE_URL1}/api/${namespace}/get/events`;
        formdata.append("date_filter", "today");
      } else if (actionType === "Future Events") {
        endpoint = `${API_BASE_URL1}/api/${namespace}/get/events`;
        formdata.append("date_filter", "future");
      } else if (actionType === "Pending Timesheet Events") {
        endpoint = `${API_BASE_URL1}/api/${namespace}/get/timesheet_pending_events`;
      } else if (actionType === "Past Events") {
        endpoint = `${API_BASE_URL1}/api/${namespace}/get/events`;
        formdata.append("date_filter", "past");

        if (period) {
          formdata.append("period", period);
        }
        if (startDate) {
          formdata.append("start_date", startDate);
        }
        if (endDate) {
          formdata.append("end_date", endDate);
        }
      } else {
        throw new Error(`Unknown action type: ${actionType}`);
      }

      // Validate endpoint before making request
      if (!endpoint) {
        throw new Error("API endpoint not configured for this action type.");
      }

      console.log(`🌐 Making request to: ${endpoint}`);
      console.log(`📋 FormData entries:`, Array.from(formdata.entries()));

      // Try with FormData first (matching the pattern of working auth APIs)
      let requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: abortControllerRef.current.signal,
        // Don't set Content-Type header - browser will set it automatically with boundary for FormData
      };

      let response;
      let text;
      let fetchError = null;

      try {
        response = await fetch(endpoint, requestOptions);
        text = await response.text();
        console.log("API Response Status:", response.status, response.statusText);
        console.log("API Response:", text);
      } catch (error) {
        fetchError = error;
        console.error("❌ First attempt (FormData) failed:", error);

        // If FormData fails, try with token in Authorization header and JSON body
        if (error.name === "TypeError" && error.message.includes("Failed to fetch")) {
          console.log("🔄 Trying alternative: Token in Authorization header with JSON body...");

          // Build JSON body
          const jsonBody = {
            access_token: trimmedToken
          };

          if (actionType === "Today's Events") {
            jsonBody.date_filter = "today";
          } else if (actionType === "Future Events") {
            jsonBody.date_filter = "future";
          } else if (actionType === "Past Events") {
            jsonBody.date_filter = "past";
            if (period) jsonBody.period = period;
            if (startDate) jsonBody.start_date = startDate;
            if (endDate) jsonBody.end_date = endDate;
          }

          // Try with Authorization header and JSON body
          requestOptions = {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${trimmedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(jsonBody),
            redirect: "follow",
            signal: abortControllerRef.current.signal,
          };

          try {
            response = await fetch(endpoint, requestOptions);
            text = await response.text();
            console.log("✅ Second attempt (Header) succeeded!");
            console.log("API Response Status:", response.status, response.statusText);
            console.log("API Response:", text);
            fetchError = null; // Clear the error since retry succeeded
          } catch (retryError) {
            console.error("❌ Second attempt (Header) also failed:", retryError);
            fetchError = retryError; // Keep the original error
          }
        }

        // If both attempts failed, throw the error
        if (fetchError) {
          // Handle different types of network errors
          if (fetchError.name === "TypeError" && fetchError.message.includes("Failed to fetch")) {
            throw new Error("Network error: Unable to reach the server. This could be due to CORS restrictions, network connectivity issues, or the server being unavailable. Please check your connection and try again.");
          } else if (fetchError.name === "AbortError") {
            return; // User cancelled, silently return
          } else {
            throw new Error(`Network error: ${fetchError.message || "Unable to connect to the server. Please try again."}`);
          }
        }
      }

      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        console.error("JSON Parse Error:", parseError);
        console.error("Response text that failed to parse:", text);
        throw new Error("Invalid response format from server. Please try again.");
      }

      // Check for token expiration
      if (response.status === 403 && (data.type === "access_token" || data.message?.includes("token") || data.message?.includes("expired"))) {
        handleTokenExpiration();
        return;
      }

      // Check for both HTTP errors and API-level errors
      if (!response.ok || (data.status === false)) {
        const errorMessage = data.error || data.message || data.msg || `HTTP ${response.status}: Unable to fetch events.`;
        throw new Error(errorMessage);
      }

      // Format and display the response
      let formattedResponse = "";

      if (data.status && Array.isArray(data.data)) {
        formattedResponse = renderEventsTable(data.data, actionType);
      } else if (Array.isArray(data.events)) {
        formattedResponse = renderEventsTable(data.events, actionType);
      } else if (data.data && Array.isArray(data.data.events)) {
        formattedResponse = renderEventsTable(data.data.events, actionType);
      } else if (data.message) {
        formattedResponse = data.message;
      } else if (data.data && !Array.isArray(data.data)) {
        // Handle case where data is not an array
        formattedResponse = `<strong>${actionType}</strong><br><br>`;
        formattedResponse += JSON.stringify(data.data, null, 2).replace(/\n/g, '<br>');
      } else {
        formattedResponse = `Response received for ${actionType}.`;
        if (data) {
          formattedResponse += `<br><br>${JSON.stringify(data, null, 2).replace(/\n/g, '<br>')}`;
        }
      }

      pushMessages({
        sender: "bot",
        text: formattedResponse,
      });

    } catch (error) {
      if (error.name === "AbortError") return;

      console.error("❌ API Error:", error);
      console.error("❌ Error name:", error.name);
      console.error("❌ Error message:", error.message);
      console.error("❌ Error stack:", error.stack);

      // Provide user-friendly error message
      let userMessage = error.message || "Unable to fetch events. Please try again.";

      // Add troubleshooting tips for network errors
      if (userMessage.includes("Failed to fetch") || userMessage.includes("Network error")) {
        userMessage += "\n\n💡 Troubleshooting tips:\n• Check your internet connection\n• The API server might be temporarily unavailable\n• There might be CORS restrictions - contact the API administrator";
      }

      pushMessages({
        sender: "bot",
        text: `❌ ${userMessage}`,
      });

    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handleMainButtonClick = (type) => {
    if (type === "helpDesk") {
      setView("helpDesk");
      setMessages([
        { sender: "bot", text: "👋 Welcome to Help Desk! Please select a question below or type your query." }
      ]);
      setEmail("");
      setOtp("");
      setPasswordInput("");
      setAuthMethod("");
      setOtpSent(false);
      setLoggedIn(false);
      setUserId("");
      setUserType("");
      setChatInput("");
      setToken("");
    } else if (type === "registeredUser") {
      setView("registeredUser");
      setMessages([
        { sender: "bot", text: "Please enter your email to continue." }
      ]);
      setEmail("");
      setOtp("");
      setPasswordInput("");
      setAuthMethod("");
      setOtpSent(false);
      setLoggedIn(false);
      setUserId("");
      setUserType("");
      setChatInput("");
      setToken("");
    }
  };

  const handleHelpDeskSuggestion = (suggestion) => {
    sendHelpDeskQuery(suggestion);
  };

  const handleEmailSubmit = async () => {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      pushMessages({ sender: "bot", text: "❌ Please enter a valid email address." });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      pushMessages({ sender: "bot", text: "❌ Please enter a valid email address." });
      return;
    }

    pushMessages({ sender: "user", text: trimmedEmail });

    setAuthMethod("waiting");
    setOtpSent(false);
    setLoggedIn(false);
    setOtp("");
    setPasswordInput("");

    setAuthButtonsDisabled(false);
    pushMessages({
      sender: "bot",
      text: "How would you like to sign in?",
      buttons: [
        { key: "otp", label: "Continue with OTP (you will receive a few numbers on your email)" },
        { key: "password", label: "Continue with Password (the password you use for the Portal or Mobile App)" },
      ],
    });
  };

  const handleSelectAuthMethod = async (method) => {
    if (authButtonsDisabled) return;
    setAuthButtonsDisabled(true);
    setAuthMethod(method);

    if (method === "otp") {
      pushMessages({ sender: "user", text: "Continue with OTP (you will receive a few numbers on your email)" });
      await sendOTP(email);
    } else if (method === "password") {
      pushMessages({ sender: "user", text: "Continue with Password (the password you use for the Portal or Mobile App)" });
      pushMessages({ sender: "bot", text: "🔒 Please enter your password below." });
    }
  };

  const handleOTPSubmit = async () => {
    const trimmedOtp = otp.trim();

    if (!trimmedOtp) {
      pushMessages({ sender: "bot", text: "❌ Please enter the OTP." });
      return;
    }

    pushMessages({ sender: "user", text: `OTP: ${trimmedOtp}` });
    await verifyOTP(email.trim(), trimmedOtp);
  };

  const handleChatSend = async () => {
    if (!chatInput.trim()) {
      return;
    }
    const query = chatInput.trim();
    setChatInput("");
    await submitUserQuery(query);
  };

  // UPDATED: Handle user suggestion clicks with API calls
  const handleUserSuggestionClick = async (suggestion) => {
    console.log("🎯 Suggestion clicked:", suggestion);
    console.log("🔐 Current loggedIn state:", loggedIn);
    console.log("🔑 Current token state:", token ? `${token.substring(0, 20)}...` : "NONE");
    console.log("👤 Current userType:", userType);

    if (suggestion === "Past Events") {
      setShowPastEventsOptions(true);
      pushMessages({
        sender: "user",
        text: suggestion,
      });
      pushMessages({
        sender: "bot",
        text: "Please select the time period for past events:",
        buttons: [
          { key: "This week", label: "This week" },
          { key: "Last week", label: "Last week" },
          { key: "This Month", label: "This Month" },
          { key: "Last Month", label: "Last Month" },
          { key: "This Quarter", label: "This Quarter" },
          { key: "This Year", label: "This Year" },
          { key: "custom", label: "Custom Date" },
        ],
      });
    } else {
      // Call API for other suggestions
      pushMessages({ sender: "user", text: suggestion });
      await callInterpreterAPI(suggestion);
    }
  };

  const fetchTicketCategories = async () => {
    setTicketCategoriesLoading(true);
    try {
      const myHeaders = new Headers();

      // Get session_id from cookies if available
      const cookies = document.cookie.split(';');
      const sessionCookie = cookies.find(cookie => cookie.trim().startsWith('session_id='));
      if (sessionCookie) {
        const sessionId = sessionCookie.split('=')[1].trim();
        myHeaders.append("Cookie", `session_id=${sessionId}`);
      }

      const formdata = new FormData();

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };

      const response = await fetch(`${API_BASE_URL1}/api/helpdesk/get_ticket_types`, requestOptions);

      if (!response.ok) {
        throw new Error("Unable to fetch ticket categories.");
      }

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseError) {
        console.error("Failed to parse response as JSON:", text);
        throw new Error("Invalid response format from server.");
      }

      if (data.ticket_types && Array.isArray(data.ticket_types)) {
        setTicketCategories(data.ticket_types);
      } else if (data.status && Array.isArray(data.data)) {
        setTicketCategories(data.data);
      } else if (Array.isArray(data)) {
        setTicketCategories(data);
      } else {
        console.warn("Unexpected ticket categories response format:", data);
        setTicketCategories([]);
      }
    } catch (error) {
      console.error("Error fetching ticket categories:", error);
      pushMessages({
        sender: "bot",
        text: "❌ Unable to load ticket categories. Please try again later.",
      });
      setTicketCategories([]);
    } finally {
      setTicketCategoriesLoading(false);
    }
  };

  const openTicketModal = () => {
    setTicketCategory("");
    setTicketSubject("");
    setTicketMessage("");
    setTicketEmail(email || "");
    setShowTicketModal(true);
    fetchTicketCategories();
  };

  const stopTicketVoiceCapture = useCallback(() => {
    if (ticketRecognitionRef.current) {
      ticketRecognitionRef.current.onresult = null;
      ticketRecognitionRef.current.onerror = null;
      try {
        ticketRecognitionRef.current.stop();
      } catch (error) {
        console.warn("Speech recognition stop error:", error);
      }
      ticketRecognitionRef.current = null;
    }
    setTicketVoiceActive(false);
  }, []);

  const closeTicketModal = () => {
    if (ticketSubmitting) return;
    stopTicketVoiceCapture();
    stopChatVoiceCapture();
    setShowTicketModal(false);
  };

  const handleTicketVoiceToggle = useCallback(async () => {
    if (ticketVoiceActive) {
      stopTicketVoiceCapture();
      return;
    }

    try {
      await ensureMicrophonePermission();
    } catch (permissionError) {
      pushMessages({
        sender: "bot",
        text: `❌ ${permissionError.message}`,
      });
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      pushMessages({
        sender: "bot",
        text: "❌ Voice input is not supported in this browser.",
      });
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setTicketMessage((prev) => (prev ? `${prev} ${transcript}` : transcript));
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      pushMessages({
        sender: "bot",
        text: "❌ Unable to capture voice input. Please try again.",
      });
      stopTicketVoiceCapture();
    };

    recognition.onend = () => {
      setTicketVoiceActive(false);
    };

    try {
      recognition.start();
      ticketRecognitionRef.current = recognition;
      setTicketVoiceActive(true);
    } catch (error) {
      console.error("Speech recognition start error:", error);
      let errorText = "❌ Unable to start voice input. Please try again.";

      if (micPermissionDenied) {
        errorText = "❌ Microphone permission is blocked. Please enable it in your browser settings.";
      }

      pushMessages({
        sender: "bot",
        text: errorText,
      });
    }
  }, [ensureMicrophonePermission, micPermissionDenied, pushMessages, stopTicketVoiceCapture, ticketVoiceActive]);

  const handleTicketSubmit = async () => {
    const finalEmail = (ticketEmail || email || "").trim();
    if (!finalEmail) {
      pushMessages({ sender: "bot", text: "❌ Please enter your email address." });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(finalEmail)) {
      pushMessages({ sender: "bot", text: "❌ Please enter a valid email address." });
      return;
    }

    const finalUserId = loggedIn ? (userId || "").toString() : "";
    console.log("🆔 User ID:", finalUserId);

    if (!ticketCategory) {
      pushMessages({ sender: "bot", text: "❌ Please select a ticket category." });
      return;
    }
    if (!ticketSubject.trim()) {
      pushMessages({ sender: "bot", text: "❌ Please enter a subject for your ticket." });
      return;
    }
    if (!ticketMessage.trim()) {
      pushMessages({ sender: "bot", text: "❌ Please describe your issue." });
      return;
    }

    setTicketSubmitting(true);
    try {
      // Find the selected category to get its id
      const selectedCategory = ticketCategories.find(
        cat => (cat.name || cat) === ticketCategory
      );
      const ticketTypeId = selectedCategory?.id || ticketCategory;

      const myHeaders = new Headers();

      // Get session_id from cookies if available
      const cookies = document.cookie.split(';');
      const sessionCookie = cookies.find(cookie => cookie.trim().startsWith('session_id='));
      if (sessionCookie) {
        const sessionId = sessionCookie.split('=')[1].trim();
        myHeaders.append("Cookie", `session_id=${sessionId}`);
      }

      const formdata = new FormData();
      formdata.append("name", finalEmail.split('@')[0] || "User"); // Use email username as name
      formdata.append("subject", ticketSubject.trim());
      formdata.append("description", ticketMessage.trim());
      formdata.append("priority", "0");
      formdata.append("partner_email", finalEmail);
      formdata.append("ticket_type_id", ticketTypeId.toString());

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };

      const response = await fetch(`${API_BASE_URL1}/api/helpdesk/create_ticket`, requestOptions);

      if (!response.ok) {
        const text = await response.text();
        let errorData;
        try {
          errorData = JSON.parse(text);
        } catch {
          errorData = { error: "Unable to raise ticket right now." };
        }
        throw new Error(errorData.error || errorData.msg || "Unable to raise ticket right now.");
      }

      const text = await response.text();
      // Parse response to check for any messages (optional)
      try {
        const result = JSON.parse(text);
        if (result.msg) {
          console.log("Ticket submission response:", result.msg);
        }
      } catch {
        // Response is not JSON, which is fine
        console.log("Ticket submitted successfully");
      }

      pushMessages({
        sender: "bot",
        text: "✅ Your ticket has been submitted! Our support team will reach out shortly.",
      });
      stopTicketVoiceCapture();
      setShowTicketModal(false);
    } catch (error) {
      console.error("Ticket Submit Error:", error);
      pushMessages({
        sender: "bot",
        text: `❌ ${error.message || "Unable to submit ticket. Please try again later."}`,
      });
    } finally {
      setTicketSubmitting(false);
    }
  };

  const handlePastEventsSelection = async (period) => {
    if (period === "custom") {
      setShowCustomDateInput(true);
      pushMessages({
        sender: "user",
        text: "Custom Date",
      });
      pushMessages({
        sender: "bot",
        text: "Please enter the date range for events (YYYY-MM-DD format):",
      });
    } else {
      setShowPastEventsOptions(false);
      pushMessages({ sender: "user", text: period });

      // Map period to API parameter keywords
      const periodMap = {
        "This week": "this_week",
        "Last week": "last_week",
        "This Month": "this_month",
        "Last Month": "last_month",
        "This Quarter": "this_quarter",
        "This Year": "this_year"
      };

      await callInterpreterAPI("Past Events", periodMap[period] || period.toLowerCase().replace(/\s+/g, ""));
    }
  };

  const handleCustomDateSubmit = async () => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (!customDateFrom.trim() || !customDateTo.trim()) {
      pushMessages({ sender: "bot", text: "❌ Please enter both From and To dates." });
      return;
    }

    if (!dateRegex.test(customDateFrom)) {
      pushMessages({ sender: "bot", text: "❌ From date must be in YYYY-MM-DD format (e.g., 2024-11-01)." });
      return;
    }

    if (!dateRegex.test(customDateTo)) {
      pushMessages({ sender: "bot", text: "❌ To date must be in YYYY-MM-DD format (e.g., 2024-11-18)." });
      return;
    }

    const fromDate = new Date(customDateFrom);
    const toDate = new Date(customDateTo);
    if (fromDate > toDate) {
      pushMessages({ sender: "bot", text: "❌ From date must be before To date." });
      return;
    }

    setShowCustomDateInput(false);
    pushMessages({ sender: "user", text: `From ${customDateFrom} to ${customDateTo}` });

    await callInterpreterAPI("Past Events", "", customDateFrom, customDateTo);

    setCustomDateFrom("");
    setCustomDateTo("");
    setShowPastEventsOptions(false);
  };

  const shouldHideInputArea =
    authMethod === "waiting" ||
    showCustomDateInput ||
    (loggedIn && !customQueryActive && view !== "helpDesk");

  useEffect(() => {
    if (shouldHideInputArea) {
      stopChatVoiceCapture();
    }
  }, [shouldHideInputArea, stopChatVoiceCapture]);

  const handleLogout = () => {
    console.log("🚪 Logging out user...");
    handleReset();
  };

  const handleReset = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.EMAIL);
    localStorage.removeItem(STORAGE_KEYS.SESSION);
    localStorage.removeItem(STORAGE_KEYS.HELP_DESK);
    localStorage.removeItem(STORAGE_KEYS.VIEW);
    localStorage.removeItem(STORAGE_KEYS.MODE);
    localStorage.removeItem("chatAppState"); // legacy cleanup

    stopTicketVoiceCapture();
    setView("initial");
    setEmail("");
    setOtp("");
    setPasswordInput("");
    setAuthMethod("");
    setOtpSent(false);
    setLoggedIn(false);
    setUserId("");
    setUserType("");
    setChatInput("");
    setInput("");
    setToken("");
    setInteractionMode("help");
    setCustomQueryActive(false);
    setModeButtonsDisabled(false);
    setAuthButtonsDisabled(false);
    setShowTimesheetModal(false);
    setTimesheetSubmitting(false);
    setTimesheetForm((prev) => ({
      ...prev,
      event_id: "",
      name: "",
      arrival_Time: "",
      arrival_am_pm: "am",
      event_start_hr: "",
      event_start_min: "",
      am_pm: "am",
      event_end_hr: "",
      event_end_min: "",
      am_pm2: "pm",
      wait_time: "",
      event_out_come_id: "1",
      travel_time: "",
      total_mileage_covered: "",
      attachment_filename: "",
      timesheet_attachment: "",
    }));
    setShowTicketModal(false);
    setTicketCategory("");
    setTicketSubject("");
    setTicketMessage("");
    setTicketEmail("");
    setTicketSubmitting(false);
    setLoading(false);
    setMessages([
      {
        sender: "bot",
        text: "Hello! I'm your AI Assistant — a smart, conversational system designed to help you access information, resolve queries, and guide you with accurate insights. To get started, please choose one of the following options: Registered User or Help Desk. Once selected, I'll walk you through the next steps and assist you instantly."
      }
    ]);
  };

  return (
    <div className="chat-container" style={styles.chatContainer}>
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(1);
            opacity: 0.5;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
        
        .loading-dot {
          animation: bounce 1.4s infinite ease-in-out;
        }
        
        .loading-dot:nth-child(1) {
          animation-delay: -0.32s;
        }
        
        .loading-dot:nth-child(2) {
          animation-delay: -0.16s;
        }

        .events-cards-wrapper {
          width: 100%;
        }

        .event-card {
          background: #ffffff;
          border: 1.5px solid #cbd5e1;
          padding: 16px;
          border-radius: 8px;
          margin-bottom: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }

        .events-table-wrapper {
          width: 100%;
          overflow-x: auto;
          overflow-y: auto;
          max-height: 104vh;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          background: #fff;
          box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.05);
        }

        .events-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
          min-width: 720px;
        }

        .events-table th,
        .events-table td {
          text-align: left;
          border-bottom: 1px solid #eee;
          padding: 8px 10px;
          white-space: nowrap;
        }

        .events-table th {
          background: #fafbfc;
          font-weight: 600;
          color: #1e1e1e;
          position: sticky;
          top: 0;
          z-index: 1;
        }

        .event-name-link {
          color: #1e5ba8 !important;
          cursor: pointer;
          text-decoration: underline;
          transition: color 0.2s;
        }

        .event-name-link:hover {
          color: #1a4d8f !important;
          text-decoration: underline;
        }

        .job-action-btn {
          transition: all 0.2s;
          white-space: nowrap;
        }

        .job-action-btn:hover {
          opacity: 0.8;
          text-decoration: underline !important;
        }

        .accept-btn:hover {
          color: #218838 !important;
        }

        .reject-btn:hover {
          color: #c82333 !important;
        }

        .how-to-use-wrapper {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 16px;
        }

        .how-to-use-wrapper a {
          font-weight: 600;
          color: #1e5ba8;
          text-decoration: underline;
          text-underline-offset: 4px;
        }

        @media (max-width: 900px) {
          .initial-view {
            padding: 36px 20px;
          }

          .welcome-section {
            margin-bottom: 32px;
          }

          .welcome-section img {
            width: 150px;
            height: 150px;
          }

          .welcome-section h2 {
            font-size: 32px;
          }

          .welcome-section p {
            font-size: 15px;
          }

          .main-buttons {
            flex-direction: column;
            max-width: 520px;
            gap: 16px;
          }

          .main-buttons button {
            width: 100%;
          }

          .how-to-use-wrapper {
            justify-content: flex-end;
          }
        }

        @media (max-width: 640px) {
          .events-cards-wrapper {
            grid-template-columns: 1fr !important;
            gap: 12px !important;
          }

          .event-card {
            padding: 12px !important;
            margin-bottom: 12px !important;
          }

          .events-table-wrapper {
            max-height: none;
          }

          .events-table {
            font-size: 12px;
            min-width: 640px;
          }

          .events-table th,
          .events-table td {
            padding: 6px 8px;
          }
        }

        .chat-container {
          width: 100%;
        }

        .chat-wrapper {
          padding-bottom: 0;
        }

        .chat-header {
          padding: 16px 24px;
        }

        .header-content {
          gap: 16px;
        }

        .chat-body {
          padding: 24px;
        }

        .input-area {
          padding: 16px 24px;
        }

        .suggestions-bar {
          padding: 12px 24px;
        }

        @media (max-width: 1024px) {
          .header-content {
            flex-wrap: wrap;
            gap: 12px;
          }

          .header-actions {
            width: auto;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 12px;
          }

          .chat-container {
            height: auto;
            min-height: 100vh;
          }

          .chat-wrapper {
            padding-bottom: env(safe-area-inset-bottom, 20px);
          }

          .chat-header {
            padding: 12px 18px;
          }

          .chat-body {
            padding: 18px;
          }

          .suggestions-bar {
            padding: 10px 18px;
          }

          .input-area {
            padding: 14px 18px;
          }
        }

        @media (max-width: 640px) {
          .header-content {
            gap: 10px;
          }

          .header-actions {
            width: auto;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 8px;
          }

          .mode-switcher {
            width: auto;
            flex-wrap: wrap;
            justify-content: flex-start;
            padding: 4px 8px;
          }

          .mode-option {
            font-size: 12px;
          }

          .chat-header {
            padding: 10px 14px;
          }

          .header-title {
            font-size: 18px;
          }

          .chat-body {
            padding: 14px;
            gap: 10px;
          }

          .input-area {
            padding: 12px 14px;
          }

          .suggestions-bar {
            padding: 10px 14px;
            gap: 6px;
          }

          .initial-view {
            padding: 32px 16px;
          }

          .initial-view {
            padding: 28px 16px;
            justify-content: flex-start;
          }

          .welcome-section {
            margin-bottom: 24px;
          }

          .welcome-section img {
            width: 130px;
            height: 130px;
          }

          .welcome-section h2 {
            font-size: 26px;
          }

          .welcome-section p {
            font-size: 14px;
          }

          .main-buttons {
            flex-direction: column;
            gap: 14px;
          }

          .main-buttons button {
            width: 100%;
          }

          .how-to-use-wrapper {
            justify-content: center;
          }
        }

        @media (max-width: 480px) {
          .welcome-section img {
            width: 120px;
            height: 120px;
          }

          .welcome-section h2 {
            font-size: 24px;
          }

          .welcome-section p {
            font-size: 13px;
          }

          .main-buttons h3 {
            font-size: 15px;
          }

          .how-to-use-wrapper a {
            font-size: 12px;
          }
        }
      `}</style>

      <div className="chat-header" style={styles.chatHeader}>
        <div className="header-content" style={styles.headerContent}>
          <div className="logo-section" style={styles.logoSection}>
            <img src="/iu_logo.png" alt="IU Logo" style={{ width: "40px", height: "40px", borderRadius: "50%" }} />
            <h1 className="header-title" style={styles.headerTitle}>IU AI Assistant</h1>
          </div>
          {view !== "initial" && (
            <div style={styles.headerActions}>
              <button
                style={styles.resetBtn}
                onClick={loggedIn ? handleLogout : handleReset}
              >
                {loggedIn ? "Logout" : "← Back Home"}
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="chat-wrapper" style={styles.chatWrapper}>
        {view === "initial" && (
          <div className="initial-view" style={styles.initialView}>
            <div className="welcome-section" style={styles.welcomeSection}>
              <img
                src="/iu_logo.png"
                alt="IU Group logo"
                style={styles.welcomeLogo}
              />
              <h2 style={styles.welcomeTitle}>Welcome to IU AI Assistant</h2>
              <p style={styles.welcomeDescription}>
                I'm your IU AI Assistant — a smart, conversational system designed to help you access information, resolve queries, and guide you with accurate insights.
              </p>
              <p style={styles.welcomeSubtext}>Choose one of the following options to get started</p>
            </div>
            <div className="main-buttons" style={styles.mainButtons}>
              <button
                style={{ ...styles.mainBtn, ...styles.registeredUserBtn }}
                onClick={() => handleMainButtonClick("registeredUser")}
              >
                <div style={styles.btnIcon}>👤</div>
                <div style={styles.btnContent}>
                  <h3 style={styles.btnTitle}>Registered User</h3>
                  <p style={styles.btnDesc}>(Interpreter or Customer)</p>
                  <p style={styles.btnDesc}>Login to access personalized features</p>
                </div>
              </button>
              <button
                style={{ ...styles.mainBtn, ...styles.helpDeskBtn }}
                onClick={() => handleMainButtonClick("helpDesk")}
              >
                <div style={styles.btnIcon}>🛟</div>
                <div style={styles.btnContent}>
                  <h3 style={styles.btnTitle}>Help Desk</h3>
                  <p style={styles.btnDesc}>Get answers to common questions</p>
                </div>
              </button>
            </div>
            <div className="how-to-use-wrapper" style={styles.howToUseWrapper}>
              <a
                href="https://drive.google.com/file/d/1fWsHS4kSxXl2ObXD9tbFfjLwAToLLtth/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.howToUseLink}
              >
                _ How to use
              </a>
            </div>
          </div>
        )}

        {view !== "initial" && (
          <>
            <div className="chat-body" style={styles.chatBody}>
              {messages.map((msg, i) => (
                <div key={i} style={msg.sender === "user" ? styles.userMsg : styles.botMsg}>
                  <div style={styles.msgContent}>
                    <div
                      className="message"
                      style={{
                        ...(msg.sender === "user" ? styles.userText : styles.botText),
                        maxWidth: "85vw",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "104vh",
                        wordBreak: "break-word",
                        WebkitOverflowScrolling: "touch"
                      }}
                      dangerouslySetInnerHTML={{ __html: msg.text }}
                    />

                    {msg.buttons && (
                      <div style={styles.buttonsContainer}>
                        {msg.buttons.map((button, btnIndex) => {
                          const isPastEventsButton =
                            ["This week", "Last week", "This Month", "Last Month", "This Quarter", "This Year"].includes(button.key) ||
                            button.key === "custom";
                          const isModeSelectionButton =
                            ["mode_help", "mode_appointment", "cancel_custom_query"].includes(button.key);
                          const isAuthSelectionButton =
                            button.key === "otp" || button.key === "password";
                          const shouldDisable =
                            (loggedIn && !showPastEventsOptions && isPastEventsButton) ||
                            (isModeSelectionButton && modeButtonsDisabled) ||
                            (isAuthSelectionButton && authButtonsDisabled);
                          return (
                            <button
                              key={btnIndex}
                              style={{
                                ...styles.actionBtn,
                                ...(shouldDisable ? styles.actionBtnDisabled : {})
                              }}
                              disabled={shouldDisable}
                              onClick={() => {
                                if (shouldDisable) return;
                                if (button.key === "otp") {
                                  handleSelectAuthMethod("otp");
                                } else if (button.key === "password") {
                                  handleSelectAuthMethod("password");
                                } else if (["This week", "Last week", "This Month", "Last Month", "This Quarter", "This Year"].includes(button.key)) {
                                  handlePastEventsSelection(button.key);
                                } else if (button.key === "custom") {
                                  handlePastEventsSelection("custom");
                                } else if (button.key === "mode_help") {
                                  handleCustomQueryModeSelect("mode_help");
                                } else if (button.key === "mode_appointment") {
                                  handleCustomQueryModeSelect("mode_appointment");
                                } else if (button.key === "cancel_custom_query") {
                                  handleCustomQueryDeactivate();
                                }
                              }}
                            >
                              {button.label}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {loading && (
                <div style={styles.botMsg}>
                  <div style={styles.loadingContainer}>
                    <div style={styles.loadingDots}>
                      <span className="loading-dot" style={styles.loadingDot}></span>
                      <span className="loading-dot" style={styles.loadingDot}></span>
                      <span className="loading-dot" style={styles.loadingDot}></span>
                    </div>
                    <p style={styles.loadingText}>Processing your request...</p>
                  </div>
                </div>
              )}

              <div ref={messagesEndRef} />
            </div>

            {view === "helpDesk" && !loading && (
              <div className="suggestions-bar" style={styles.suggestionsBar}>
                {HELP_DESK_SUGGESTIONS.map((suggestion, i) => {
                  const isObjectSuggestion = typeof suggestion === "object";
                  const label = isObjectSuggestion ? suggestion.label : suggestion;

                  return (
                    <button
                      key={i}
                      style={{
                        ...styles.suggestionBtn,
                        ...(isObjectSuggestion && suggestion.type === "ticket" ? styles.suggestionLinkBtn : {})
                      }}
                      disabled={loading}
                      onClick={() => {
                        if (isObjectSuggestion && suggestion.type === "ticket") {
                          openTicketModal();
                        } else {
                          handleHelpDeskSuggestion(label);
                        }
                      }}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            )}

            {loggedIn && !loading && (
              <div className="suggestions-bar" style={styles.suggestionsBar}>
                {(USER_TYPE_SUGGESTIONS[userType] || []).map((suggestion, idx) => {
                  const isObjectSuggestion = typeof suggestion === "object";
                  const label = isObjectSuggestion ? suggestion.label : suggestion;

                  return (
                    <button
                      key={idx}
                      style={{
                        ...styles.suggestionBtn,
                        ...(isObjectSuggestion && suggestion.type === "ticket" ? styles.suggestionLinkBtn : {})
                      }}
                      disabled={loading}
                      onClick={() => {
                        if (isObjectSuggestion) {
                          if (suggestion.type === "ticket") {
                            openTicketModal();
                          } else if (suggestion.url) {
                            window.open(suggestion.url, "_blank", "noopener,noreferrer");
                          }
                        } else {
                          handleUserSuggestionClick(label);
                        }
                      }}
                    >
                      {label}
                    </button>
                  );
                })}
                {!customQueryActive ? (
                  <button
                    style={{ ...styles.suggestionBtn, ...styles.customQueryBtn }}
                    onClick={handleCustomQueryActivate}
                    disabled={loading}
                  >
                    Ask Query
                  </button>
                ) : (
                  <button
                    style={{
                      ...styles.suggestionBtn,
                      ...styles.customQueryBtn,
                      backgroundColor: '#ffeaea',
                      color: '#c62828',
                      borderColor: '#ffcdd2'
                    }}
                    onClick={handleCustomQueryDeactivate}
                    disabled={loading}
                  >
                    Disable Query Mode
                  </button>
                )}
              </div>
            )}

            {showCustomDateInput && (
              <div style={styles.customDateContainer}>
                <div style={styles.dateRangeWrapper}>
                  <div style={styles.dateInputGroup}>
                    <label style={styles.dateLabel}>From Date:</label>
                    <input
                      type="date"
                      value={customDateFrom}
                      onChange={(e) => setCustomDateFrom(e.target.value)}
                      style={styles.customDateInput}
                    />
                  </div>
                  <div style={styles.dateInputGroup}>
                    <label style={styles.dateLabel}>To Date:</label>
                    <input
                      type="date"
                      value={customDateTo}
                      onChange={(e) => setCustomDateTo(e.target.value)}
                      style={styles.customDateInput}
                    />
                  </div>
                </div>
                <div style={styles.dateButtonGroup}>
                  <button
                    onClick={handleCustomDateSubmit}
                    style={styles.customDateBtn}
                  >
                    Send
                  </button>
                  <button
                    onClick={() => {
                      setShowCustomDateInput(false);
                      setCustomDateFrom("");
                      setCustomDateTo("");
                      setShowPastEventsOptions(false);
                    }}
                    style={{ ...styles.customDateBtn, backgroundColor: '#ff6b6b' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {showTicketModal && (
              <div style={styles.modalOverlay} onClick={closeTicketModal}>
                <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                  <div style={styles.modalHeader}>
                    <h3 style={styles.modalTitle}>Raise Support Ticket</h3>
                    <button style={styles.modalCloseBtn} onClick={closeTicketModal} disabled={ticketSubmitting}>
                      ✕
                    </button>
                  </div>
                  <div style={styles.modalBody}>
                    <label style={styles.modalLabel}>Subject</label>
                    <input
                      type="text"
                      value={ticketSubject}
                      onChange={(e) => setTicketSubject(e.target.value)}
                      placeholder="Enter ticket subject"
                      style={styles.modalInput}
                      disabled={ticketSubmitting}
                    />

                    <label style={styles.modalLabel}>Email Address</label>
                    <input
                      type="email"
                      value={ticketEmail}
                      onChange={(e) => setTicketEmail(e.target.value)}
                      placeholder="Enter your email"
                      style={styles.modalInput}
                      disabled={ticketSubmitting}
                    />

                    <label style={styles.modalLabel}>Category</label>
                    <select
                      value={ticketCategory}
                      onChange={(e) => setTicketCategory(e.target.value)}
                      style={styles.modalSelect}
                      disabled={ticketSubmitting || ticketCategoriesLoading}
                    >
                      <option value="">{ticketCategoriesLoading ? "Loading categories..." : "Select Category"}</option>
                      {ticketCategories.map((category, idx) => (
                        <option key={idx} value={category.name || category}>
                          {category.name || category}
                        </option>
                      ))}
                    </select>

                    <div style={styles.modalLabelRow}>
                      <label style={{ ...styles.modalLabel, marginTop: 12 }}>Description</label>
                      <button
                        type="button"
                        style={{
                          ...styles.voiceBtn,
                          ...(ticketVoiceActive ? styles.voiceBtnActive : {})
                        }}
                        onClick={handleTicketVoiceToggle}
                        disabled={ticketSubmitting}
                      >
                        {ticketVoiceActive ? "⏹ Stop" : "🎤 Voice"}
                      </button>
                    </div>
                    <textarea
                      value={ticketMessage}
                      onChange={(e) => setTicketMessage(e.target.value)}
                      placeholder="Describe your issue..."
                      style={styles.modalTextarea}
                      rows={5}
                      disabled={ticketSubmitting}
                    />
                  </div>
                  <div style={styles.modalFooter}>
                    <button
                      style={{ ...styles.modalBtn, ...styles.modalCancelBtn }}
                      onClick={closeTicketModal}
                      disabled={ticketSubmitting}
                    >
                      Cancel
                    </button>
                    <button
                      style={{ ...styles.modalBtn, ...styles.modalPrimaryBtn }}
                      onClick={handleTicketSubmit}
                      disabled={ticketSubmitting}
                    >
                      {ticketSubmitting ? "Sending..." : "Send Ticket"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showTimesheetModal && (
              <div style={styles.modalOverlay} onClick={closeTimesheetModal}>
                <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                  <div style={styles.modalHeader}>
                    <h3 style={styles.modalTitle}>Fill Timesheet</h3>
                    <button style={styles.modalCloseBtn} onClick={closeTimesheetModal} disabled={timesheetSubmitting}>
                      ✕
                    </button>
                  </div>
                  <div style={styles.modalBody}>
                    <label style={styles.modalLabel}>Event</label>
                    <input
                      type="text"
                      value={timesheetForm.name}
                      onChange={(e) => handleTimesheetInputChange("name", e.target.value)}
                      placeholder="Event name"
                      style={styles.modalInput}
                      disabled={timesheetSubmitting}
                    />

                    <label style={styles.modalLabel}>Arrival Time</label>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <input
                        type="number"
                        value={timesheetForm.arrival_Time}
                        onChange={(e) => handleTimesheetInputChange("arrival_Time", e.target.value)}
                        placeholder="Hour (e.g., 10)"
                        style={styles.modalInput}
                        disabled={timesheetSubmitting}
                      />
                      <select
                        value={timesheetForm.arrival_am_pm}
                        onChange={(e) => handleTimesheetInputChange("arrival_am_pm", e.target.value)}
                        style={styles.modalSelect}
                        disabled={timesheetSubmitting}
                      >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </select>
                    </div>

                    <label style={styles.modalLabel}>Event Start Time</label>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <input
                        type="number"
                        value={timesheetForm.event_start_hr}
                        onChange={(e) => handleTimesheetInputChange("event_start_hr", e.target.value)}
                        placeholder="Hr"
                        style={styles.modalInput}
                        disabled={timesheetSubmitting}
                      />
                      <input
                        type="number"
                        value={timesheetForm.event_start_min}
                        onChange={(e) => handleTimesheetInputChange("event_start_min", e.target.value)}
                        placeholder="Min"
                        style={styles.modalInput}
                        disabled={timesheetSubmitting}
                      />
                      <select
                        value={timesheetForm.am_pm}
                        onChange={(e) => handleTimesheetInputChange("am_pm", e.target.value)}
                        style={styles.modalSelect}
                        disabled={timesheetSubmitting}
                      >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </select>
                    </div>

                    <label style={styles.modalLabel}>Event End Time</label>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <input
                        type="number"
                        value={timesheetForm.event_end_hr}
                        onChange={(e) => handleTimesheetInputChange("event_end_hr", e.target.value)}
                        placeholder="Hr"
                        style={styles.modalInput}
                        disabled={timesheetSubmitting}
                      />
                      <input
                        type="number"
                        value={timesheetForm.event_end_min}
                        onChange={(e) => handleTimesheetInputChange("event_end_min", e.target.value)}
                        placeholder="Min"
                        style={styles.modalInput}
                        disabled={timesheetSubmitting}
                      />
                      <select
                        value={timesheetForm.am_pm2}
                        onChange={(e) => handleTimesheetInputChange("am_pm2", e.target.value)}
                        style={styles.modalSelect}
                        disabled={timesheetSubmitting}
                      >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                      </select>
                    </div>

                    <label style={styles.modalLabel}>Wait Time (hrs)</label>
                    <input
                      type="number"
                      value={timesheetForm.wait_time}
                      onChange={(e) => handleTimesheetInputChange("wait_time", e.target.value)}
                      placeholder="0.5"
                      style={styles.modalInput}
                      disabled={timesheetSubmitting}
                    />

                    <label style={styles.modalLabel}>Travel Time (hrs)</label>
                    <input
                      type="number"
                      value={timesheetForm.travel_time}
                      onChange={(e) => handleTimesheetInputChange("travel_time", e.target.value)}
                      placeholder="1.5"
                      style={styles.modalInput}
                      disabled={timesheetSubmitting}
                    />

                    <label style={styles.modalLabel}>Total Mileage</label>
                    <input
                      type="number"
                      value={timesheetForm.total_mileage_covered}
                      onChange={(e) => handleTimesheetInputChange("total_mileage_covered", e.target.value)}
                      placeholder="Miles covered"
                      style={styles.modalInput}
                      disabled={timesheetSubmitting}
                    />

                    <label style={styles.modalLabel}>Event Outcome</label>
                    <select
                      value={timesheetForm.event_out_come_id}
                      onChange={(e) => handleTimesheetInputChange("event_out_come_id", e.target.value)}
                      style={styles.modalSelect}
                      disabled={timesheetSubmitting}
                    >
                      <option value="1">Completed</option>
                      <option value="2">Cancelled</option>
                      <option value="3">No Show</option>
                    </select>

                    <label style={styles.modalLabel}>Attachment (optional)</label>
                    <input
                      type="file"
                      accept="image/*,.pdf"
                      onChange={handleTimesheetFileChange}
                      style={styles.modalInput}
                      disabled={timesheetSubmitting}
                    />
                    {timesheetForm.attachment_filename && (
                      <small style={{ color: "#555" }}>Selected: {timesheetForm.attachment_filename}</small>
                    )}
                  </div>
                  <div style={styles.modalFooter}>
                    <button
                      style={{ ...styles.modalBtn, ...styles.modalCancelBtn }}
                      onClick={closeTimesheetModal}
                      disabled={timesheetSubmitting}
                    >
                      Cancel
                    </button>
                    <button
                      style={{ ...styles.modalBtn, ...styles.modalPrimaryBtn }}
                      onClick={handleTimesheetSubmit}
                      disabled={timesheetSubmitting}
                    >
                      {timesheetSubmitting ? "Submitting..." : "Submit Timesheet"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            <div className="input-area" style={{
              ...styles.inputArea,
              ...(shouldHideInputArea ? styles.inputAreaHidden : {})
            }}>
              {!authMethod && !loggedIn && view === "registeredUser" && (
                <div className="form-group" style={styles.formGroup}>
                  <input
                    type="email"
                    value={email}
                    placeholder="Enter your email address"
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleEmailSubmit()}
                    disabled={loading}
                    style={styles.input}
                  />
                  <button
                    onClick={handleEmailSubmit}
                    disabled={loading}
                    style={styles.sendBtn}
                  >
                    Continue
                  </button>
                </div>
              )}

              {authMethod === 'otp' && otpSent && !loggedIn && (
                <div className="form-group" style={styles.formGroup}>
                  <input
                    type="text"
                    value={otp}
                    placeholder="Enter OTP"
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                    onKeyDown={(e) => e.key === "Enter" && handleOTPSubmit()}
                    disabled={loading}
                    style={styles.input}
                  />
                  <button
                    onClick={handleOTPSubmit}
                    disabled={loading}
                    style={styles.sendBtn}
                  >
                    {loading ? "Verifying..." : "Verify"}
                  </button>
                </div>
              )}

              {authMethod === 'password' && !loggedIn && (
                <div className="form-group" style={styles.formGroup}>
                  <input
                    type="password"
                    value={passwordInput}
                    placeholder="Enter your password"
                    onChange={(e) => setPasswordInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handlePasswordLogin()}
                    disabled={loading}
                    style={styles.input}
                  />
                  <button
                    onClick={handlePasswordLogin}
                    disabled={loading}
                    style={styles.sendBtn}
                  >
                    {loading ? "Verifying..." : "Login"}
                  </button>
                </div>
              )}

              {(view === "helpDesk" || (loggedIn && customQueryActive)) && (
                <div className="form-group" style={{ ...styles.formGroup, position: 'relative' }}>
                  <div style={styles.voiceInputWrapper}>
                    <button
                      type="button"
                      onClick={handleChatVoiceToggle}
                      style={{
                        ...styles.chatVoiceBtn,
                        ...(chatVoiceActive ? styles.chatVoiceBtnActive : {})
                      }}
                      disabled={loading}
                      aria-pressed={chatVoiceActive}
                      aria-label={chatVoiceActive ? "Stop voice input" : "Start voice input"}
                      title={chatVoiceActive ? "Stop voice input" : "Start voice input"}
                    >
                      <img
                        src="/mic.png"
                        alt="Voice input"
                        style={{
                          ...styles.chatVoiceIcon,
                          ...(chatVoiceActive ? styles.chatVoiceIconActive : {})
                        }}
                      />
                    </button>
                    <input
                      ref={view === "helpDesk" ? inputElementRef : chatInputElementRef}
                      type="text"
                      value={view === "helpDesk" ? input : chatInput}
                      placeholder={loggedIn ? `Ask your IU-related question...` : "Ask your IU-related query..."}
                      onChange={(e) => {
                        if (view === "helpDesk") {
                          setInput(e.target.value);
                        } else {
                          setChatInput(e.target.value);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.keyCode === 13) {
                          e.preventDefault();
                          e.stopPropagation();

                          if (loading) {
                            return;
                          }

                          const currentInputValue = view === "helpDesk" ? input : chatInput;
                          const trimmedInput = currentInputValue ? currentInputValue.trim() : "";

                          // If there's text in input, always send the query
                          if (trimmedInput) {
                            if (view === "helpDesk") {
                              const query = trimmedInput;
                              setInput("");
                              setShowSuggestions(false);
                              sendHelpDeskQuery(query);
                            } else if (loggedIn) {
                              setChatInput("");
                              setShowSuggestions(false);
                              submitUserQuery(trimmedInput);
                            }
                          }
                          // If no text but suggestions are showing, select first suggestion
                          else if (showSuggestions && filteredSuggestions.length > 0) {
                            const firstSuggestion = typeof filteredSuggestions[0] === "string"
                              ? filteredSuggestions[0]
                              : filteredSuggestions[0].label;
                            if (view === "helpDesk") {
                              setInput(firstSuggestion);
                            } else {
                              setChatInput(firstSuggestion);
                            }
                            setShowSuggestions(false);
                          }
                        } else if (e.key === "ArrowDown" && showSuggestions && filteredSuggestions.length > 0) {
                          e.preventDefault();
                          // Focus first suggestion
                        } else if (e.key === "Escape") {
                          setShowSuggestions(false);
                        }
                      }}
                      onFocus={() => {
                        // Disable suggestions in appointment mode
                        if (interactionMode === "appointment") {
                          setShowSuggestions(false);
                          return;
                        }
                        const currentInput = view === "helpDesk" ? input : chatInput;
                        if (currentInput && currentInput.trim().length > 0) {
                          filterSuggestions(currentInput);
                        }
                      }}
                      onBlur={() => {
                        // Delay to allow click on suggestion
                        setTimeout(() => setShowSuggestions(false), 200);
                      }}
                      disabled={loading}
                      style={styles.chatTextInput}
                    />
                  </div>
                  {showSuggestions && filteredSuggestions.length > 0 && interactionMode !== "appointment" && (
                    <div style={{
                      position: 'absolute',
                      bottom: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: 'white',
                      border: '1px solid #e2e8f0',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      zIndex: 1000,
                      marginBottom: '8px'
                    }}>
                      {filteredSuggestions.map((suggestion, index) => {
                        const suggestionText = typeof suggestion === "string" ? suggestion : suggestion.label;
                        return (
                          <div
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault(); // Prevent input blur
                              if (view === "helpDesk") {
                                setInput(suggestionText);
                                setTimeout(() => {
                                  if (inputElementRef.current) {
                                    inputElementRef.current.focus();
                                  }
                                }, 10);
                              } else {
                                setChatInput(suggestionText);
                                setTimeout(() => {
                                  if (chatInputElementRef.current) {
                                    chatInputElementRef.current.focus();
                                  }
                                }, 10);
                              }
                              setShowSuggestions(false);
                            }}
                            style={{
                              padding: '10px 16px',
                              cursor: 'pointer',
                              borderBottom: index < filteredSuggestions.length - 1 ? '1px solid #e2e8f0' : 'none',
                              fontSize: '14px',
                              color: '#333',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7f9fc'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                          >
                            {suggestionText}
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {loading ? (
                    <button
                      onClick={stopLoading}
                      style={{ ...styles.sendBtn, ...styles.stopBtnInline }}
                    >
                      ⏹️ Stop
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        if (view === "helpDesk" && input.trim()) {
                          const query = input.trim();
                          setInput("");
                          sendHelpDeskQuery(query);
                        } else if (loggedIn) {
                          handleChatSend();
                        }
                      }}
                      disabled={loading}
                      style={styles.sendBtn}
                    >
                      Send
                    </button>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100vh',
    backgroundColor: '#f0f2f5',
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    overflow: 'hidden',
  },
  chatHeader: {
    position: 'sticky',
    top: 0,
    background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
    color: '#000',
    padding: '16px 24px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    zIndex: 100,
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  modeSwitcher: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#fff',
    padding: '4px 10px',
    borderRadius: '24px',
    border: '1px solid #d3e2ff',
    boxShadow: '0 1px 4px rgba(30,91,168,0.12)',
    fontSize: '12px',
  },
  modeLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#1e5ba8',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
  },
  modeOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    color: '#1e1e1e',
    fontWeight: 500,
    cursor: 'pointer',
  },
  modeRadio: {
    accentColor: '#1e5ba8',
    width: '12px',
    height: '12px',
    cursor: 'pointer',
  },
  logoSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  headerTitle: {
    margin: 0,
    fontSize: '20px',
    fontWeight: '600',
  },
  resetBtn: {
    backgroundColor: 'transparent',
    color: '#1e5ba8',
    border: '2px solid #1e5ba8',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  chatWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
  initialView: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px 32px',
    background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)',
    overflowY: 'auto',
  },
  welcomeSection: {
    textAlign: 'center',
    marginBottom: '40px',
    maxWidth: '720px',
    width: '100%',
  },
  welcomeLogo: {
    width: '170px',
    height: '170px',
    objectFit: 'contain',
    marginBottom: '18px',
  },
  welcomeTitle: {
    fontSize: '38px',
    fontWeight: '700',
    color: '#000',
    margin: '0 0 14px 0',
  },
  welcomeDescription: {
    fontSize: '16px',
    color: '#555',
    margin: '12px auto',
    lineHeight: '1.7',
    maxWidth: '640px',
  },
  welcomeSubtext: {
    fontSize: '14px',
    color: '#666',
    margin: '16px 0 0 0',
    fontWeight: '500',
  },
  mainButtons: {
    display: 'flex',
    gap: '20px',
    maxWidth: '650px',
    width: '100%',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  howToUseWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
  },
  howToUseLink: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#1e5ba8',
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
    transition: 'color 0.3s',
  },
  mainBtn: {
    flex: '1',
    minWidth: '180px',
    padding: '24px 20px',
    fontSize: '15px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
  },
  registeredUserBtn: {
    background: 'linear-gradient(135deg, #1e5ba8 0%, #1a4d8f 100%)',
    color: 'white',
  },
  helpDeskBtn: {
    background: 'linear-gradient(135deg, #1e5ba8 0%, #1a4d8f 100%)',
    color: 'white',
  },
  btnIcon: {
    fontSize: '32px',
  },
  btnContent: {
    textAlign: 'center',
  },
  btnTitle: {
    margin: '0 0 6px 0',
    fontSize: '16px',
  },
  btnDesc: {
    margin: 0,
    fontSize: '12px',
    opacity: 0.9,
  },
  chatBody: {
    flex: 1,
    overflowY: 'auto',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  userMsg: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },
  botMsg: {
    display: 'flex',
    gap: '12px',
    marginBottom: '8px',
  },
  msgContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  userText: {
    backgroundColor: '#1e5ba8',
    color: 'white',
    padding: '12px 16px',
    borderRadius: '16px',
    maxWidth: '70%',
    wordWrap: 'break-word',
    lineHeight: '1.4',
  },
  botText: {
    backgroundColor: 'white',
    color: '#333',
    padding: '12px 16px',
    borderRadius: '16px',
    maxWidth: '70%',
    wordWrap: 'break-word',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    lineHeight: '1.4',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    backgroundColor: 'white',
    padding: '20px 24px',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  loadingDots: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#1e5ba8',
  },
  loadingText: {
    margin: '0',
    fontSize: '14px',
    color: '#666',
    fontWeight: '500',
  },
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '8px',
  },
  actionBtn: {
    backgroundColor: '#f0f2f5',
    color: '#1e5ba8',
    border: '2px solid #1e5ba8',
    padding: '8px 14px',
    borderRadius: '20px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  actionBtnDisabled: {
    backgroundColor: '#e0e0e0',
    color: '#999',
    border: '2px solid #ccc',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  suggestionsBar: {
    padding: '12px 24px',
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: 'white',
    maxHeight: '100px',
    overflowY: 'auto',
  },
  suggestionBtn: {
    backgroundColor: '#f0f2f5',
    color: '#1e5ba8',
    border: '1px solid #e0e0e0',
    padding: '8px 14px',
    borderRadius: '20px',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '500',
    transition: 'all 0.3s',
  },
  suggestionLinkBtn: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#1e5ba8',
    padding: '0 6px',
    textDecoration: 'underline',
    fontWeight: 600,
  },
  customQueryBtn: {
    backgroundColor: '#1e5ba8',
    color: '#fff',
    borderColor: '#1e5ba8',
    fontWeight: 600,
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    padding: '16px',
  },
  modalContent: {
    width: '100%',
    maxWidth: '600px',
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#1e1e1e',
  },
  modalCloseBtn: {
    background: 'transparent',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#555',
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  modalLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#1e1e1e',
  },
  modalLabelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
  },
  modalSelect: {
    borderRadius: '10px',
    border: '1px solid #d7dfe8',
    padding: '10px 12px',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
  },
  modalInput: {
    borderRadius: '10px',
    border: '1px solid #d7dfe8',
    padding: '10px 12px',
    fontSize: '14px',
    outline: 'none',
    fontFamily: 'inherit',
  },
  modalTextarea: {
    borderRadius: '12px',
    border: '1px solid #d7dfe8',
    padding: '12px',
    fontSize: '14px',
    resize: 'vertical',
    fontFamily: 'inherit',
    minHeight: '120px',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '4px',
    flexWrap: 'wrap',
  },
  modalBtn: {
    border: 'none',
    borderRadius: '999px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  modalCancelBtn: {
    backgroundColor: '#f5f5f5',
    color: '#555',
  },
  modalPrimaryBtn: {
    backgroundColor: '#1e5ba8',
    color: '#fff',
  },
  voiceBtn: {
    border: '1px solid #1e5ba8',
    backgroundColor: '#e9f1ff',
    color: '#1e5ba8',
    borderRadius: '999px',
    padding: '6px 14px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  voiceBtnActive: {
    backgroundColor: '#1e5ba8',
    color: '#fff',
  },
  customDateContainer: {
    padding: '16px 24px',
    backgroundColor: 'white',
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  dateRangeWrapper: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  dateInputGroup: {
    flex: 1,
    minWidth: '200px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  dateLabel: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
  },
  customDateInput: {
    padding: '10px 12px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.3s',
  },
  dateButtonGroup: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
  },
  customDateBtn: {
    backgroundColor: '#1e5ba8',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  '@media (max-width: 640px)': {
    modalContent: {
      maxWidth: '95vw',
      padding: '16px',
    },
    modalHeader: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '8px',
    },
    modalFooter: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    modalBtn: {
      width: '100%',
      textAlign: 'center',
    },
  },
  inputArea: {
    padding: '16px 24px',
    backgroundColor: 'white',
    borderTop: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
  },
  inputAreaHidden: {
    display: 'none',
  },
  formGroup: {
    display: 'flex',
    gap: '10px',
    maxWidth: '100%',
    width: '100%',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  voiceInputWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    border: '2px solid #e0e0e0',
    borderRadius: '24px',
    padding: '0 8px 0 4px',
    backgroundColor: '#fff',
    transition: 'border-color 0.3s, box-shadow 0.3s',
  },
  chatVoiceBtn: {
    border: 'none',
    background: 'transparent',
    color: '#1e5ba8',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    transition: 'background-color 0.3s, color 0.3s',
  },
  chatVoiceBtnActive: {
    backgroundColor: '#ffe2e2',
    borderColor: '#ff7b7b',
    boxShadow: '0 0 0 3px rgba(255,123,123,0.2)',
  },
  chatVoiceIcon: {
    width: '18px',
    height: '18px',
    objectFit: 'contain',
    pointerEvents: 'none',
    filter: 'brightness(0) saturate(100%) invert(17%) sepia(87%) saturate(1441%) hue-rotate(184deg) brightness(92%) contrast(99%)',
    transition: 'filter 0.3s',
  },
  chatVoiceIconActive: {
    filter: 'invert(23%) sepia(94%) saturate(2995%) hue-rotate(353deg) brightness(99%) contrast(103%)',
  },
  chatTextInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: '14px',
    padding: '12px 8px',
    fontFamily: 'inherit',
    backgroundColor: 'transparent',
  },
  input: {
    flex: 1,
    padding: '12px 16px',
    border: '2px solid #e0e0e0',
    borderRadius: '24px',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.3s',
    fontFamily: 'inherit',
  },
  sendBtn: {
    backgroundColor: '#1e5ba8',
    color: 'white',
    border: 'none',
    padding: '12px 28px',
    borderRadius: '24px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  stopBtnInline: {
    backgroundColor: '#ff6b6b',
  }
};

export default App;
